(function() {
    'use strict';

    angular
        .module('ticket.controller.site', [
        	
        ]);
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.site')
        .controller('ticket.controller.site.home', [
          '$state',
          'common',
          '$timeout',
          'ticket.service.venda.venda',
          'ticket.service.venda.dashboard',
          function($state, common, $timeout, vendaSvc, dashboardSvc){
            var vm = common.controller.grid(this, dashboardSvc);
            vm.page = 0;
            vm.items = [];
            vm.searching = false;
            vm.complete = false;
            vm.sh = false;
            vm.NotResult = false;
            var pageSize = 20;
            vm.loading = true;
            vm.empty = false;

            $timeout(function() {
              angular.element('#SEARCH').triggerHandler('click');
            }, 1000);

            vm.search = function(inScroll) {

              vm.sh = true;
              if (vm.searching) return;
              vm.searching = true;

              if (!inScroll) {
                vm.page = 0;
                vm.complete = false;
                vm.items = [];
              }

              setTimeout(function () {
              dashboardSvc.getAll({
                Config: {
                  Skip: vm.page,
                  Top: pageSize
                },
                Filter: {}
              }).then(
                function (data) {

                  vm.items = vm.items.concat(data);

                  vm.loading = false;

                  // var qtdVendas = 0;
                  // data.forEach(function (itm) {
                  //   qtdVendas += itm.Vendas.length;
                  // })

                  if (data.length < pageSize)
                    vm.complete = true;

                  if (data.length > 0) {
                    vm.NotResult = false;
                    vm.page += 1;
                  }
                  else {
                    vm.NotResult = true;
                  }
                }
              ).finally(function () {
                vm.searching = false;
                if(vm.items.length == 0)
                  vm.empty = true;
              });
              },1000)

            }

            vm.click = function (item) {
              $state.go('site.detalhe', {IdSessao : item.IdSessao})
            }

        }]);


})();


(function () {
  'use strict';

  angular
    .module('ticket.controller.site')
    .controller('ticket.controller.site.detalhe', [
      '$state',
      '$scope',
      'common',
      '$timeout',
      '$filter',
      '$linq',
      'ticket.service.venda.dashboard',
      function (
        $state,
        $scope,
        common,
        $timeout,
        $filter,
        $linq,
        dashboardSvc) {
        var vm = common.controller.instantiate(this);

        if ($state.params.IdSessao) {
          dashboardSvc.obterdashboard({ IdSessao: $state.params.IdSessao }).then(
            function (resp)
            {              
              var $vendidos   = $linq.Enumerable().From(resp.Vendidos);
              var $devolvidos = $linq.Enumerable().From(resp.Cancelados);

              var totVenda    = { Valor:  $vendidos.Sum( '$.Valor' ), Quantidade: $vendidos.Sum( '$.Quantidade' ) };
              var totDevol    = { Valor:  $devolvidos.Sum( '$.Valor' ), Quantidade: $devolvidos.Sum( '$.Quantidade' ) };

              var sum = function (key, g) {
                  return  { TipoFormaPagamento: key, Valor: g.Sum("$.Valor"), Quantidade: g.Sum("$.Quantidade") }
              }

              vm.estrutura = {
                NomeAtracao: resp.Lotacao.NomeAtracao,
                DataHoraInicio: resp.Lotacao.DataHoraInicio,
                QuantidadeOcupado: resp.Lotacao.QuantidadeOcupado,
                QtdLugaresMaxima: resp.Lotacao.QtdLugaresMaxima,
                Preenchido: (resp.Lotacao.QuantidadeOcupado / resp.Lotacao.QtdLugaresMaxima) * 100,
                Faturado : totVenda.Valor - totDevol.Valor,

                Grid: {
                  Vendidos:   { dados: $vendidos.GroupBy( '$.TipoFormaPagamento', null, sum ).ToArray(), Total: totVenda } ,
                  Devolvidos: { dados: $devolvidos.GroupBy( '$.TipoFormaPagamento', null, sum ).ToArray(), Total: totDevol }
                },

                Chart: {
                  labels: [],
                  series: ['Vendas', 'Devoluções'],
                  colors: ['#1c84c6', '#ED5565'],
                  
                  quantidade: {
                    data: [[], []],
                    options : {
                      
                      legend: { display: true },
                      title: { display: true, text: 'Ingressos vendidos' },
                      tooltips: { mode: 'index', intersect: false },
                      responsive: true
                    }
                  },

                  valor: {
                    data: [[], []],
                    options : {
                      legend: { display: true },
                      title: { display: true, text: 'Faturamento' },
                      tooltips: { mode: 'index', intersect: false },
                      responsive: true
                    }
                  }
                }
              }

              console.log(vm.estrutura.Grid);

              var minDate = (function (d1, d2) { return (d1 < d2) ? d1 : d2; })(new Date($vendidos.Min('$.DataOperacao')), new Date($devolvidos.Min('$.DataOperacao')));
              var maxDate = (function (d1, d2) { return (d1 > d2) ? d1 : d2; })(new Date($vendidos.Max('$.DataOperacao')), new Date($devolvidos.Max('$.DataOperacao')));

              var currDate = minDate;

              while (currDate <= maxDate) {
                vm.estrutura.Chart.labels.push($filter('date')(currDate, "dd/MM"));

                var where = function (itm) { return new Date(itm.DataOperacao).getTime() === currDate.getTime(); };
                
                vm.estrutura.Chart.quantidade.data[0].push($vendidos.Where(where).Sum('$.Quantidade'));
                vm.estrutura.Chart.quantidade.data[1].push($devolvidos.Where(where).Sum('$.Quantidade'));

                vm.estrutura.Chart.valor.data[0].push($vendidos.Where(where).Sum('$.Valor'));
                vm.estrutura.Chart.valor.data[1].push($devolvidos.Where(where).Sum('$.Valor'));

                currDate.setDate(currDate.getDate() + 1);
              }
            }
          )

          // dashboardSvc.dashboarddetalhevendasportipoingressoprodutor({IdSessao : $state.params.IdSessao}).then(function (resp) {

          //   vm.DetalheTipoIngresso = resp;

          //   vm.getTotal = function () {
          //     var toting = 0;
          //     var totper = 0.0;

          //     // resp.forEach(function (itm) {
          //     //   toting += itm.QuantidadeVendida;
          //     //   totper += itm.PercentualVendido;
          //     // })

          //     toting =  resp.map(function(itm){return itm.QuantidadeVendida}).reduce(function(prev, next){
          //       return prev + next
          //     })

          //     totper = resp.map(function(itm){return itm.PercentualVendido}).reduce(function(prev, next){
          //       return prev + next
          //     })

          //     vm.totais = {
          //       toting : toting,
          //       totper : totper,
          //     }

          //     return vm.totais;
          //   }
          // });
        }
        else {
          $state.go('site.home');
        }

        vm.back = function () {
          $state.go('site.home');
        }
      }]);
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.operacao', []);
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendasite.grid', [
      '$state',
      '$scope',
      'common',
      '$stateParams',
      'ticket.service.venda.vendasite',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracao',
      function ($state, $scope,common, $stateParams, vendaSiteSvc, estabelecimentoSvc, atracaoSvc) {
        var vm = common.controller.grid(this, vendaSiteSvc);
        //
        // if($stateParams.Filter)
        //   vm.Filter = $stateParams.Filter;

        if($stateParams.Filter) {
          vm.Filter = {
            IdEstabelecimento : $stateParams.Filter.IdEstabelecimento,
            IdAtracao : parseInt($stateParams.Filter.IdAtracao),
            DataVendaInicio:$stateParams.Filter.DataVendaInicio,
            DataVendaFim:$stateParams.Filter.DataVendaFim,
            IdTipoStatusPagamento :$stateParams.Filter.IdTipoStatusPagamento
          }
        }

        estabelecimentoSvc.listgestao({}).then(function (list) { vm.estabelecimentoList = list; });

        vm.lstStatus = [];

        vm.lstStatus.push({IdTipoStatusPagamento : 1 , Nome : 'Aprovado'})
        vm.lstStatus.push({IdTipoStatusPagamento : 2 , Nome : 'Cancelada'})
        vm.lstStatus.push({IdTipoStatusPagamento : 3 , Nome : 'Reprovada'})
        vm.lstStatus.push({IdTipoStatusPagamento : 4 , Nome : 'Em análise'})
        vm.lstStatus.push({IdTipoStatusPagamento : 5 , Nome : 'Devolvido'})


        $scope.$watch('vm.Filter.IdEstabelecimento', function() {
          if(vm.Filter.IdEstabelecimento){

            if(vm.Filter.IdAtracao)
                vm.Filter.IdAtracao = null;

            if($stateParams.Filter)
              vm.Filter.IdAtracao = parseInt($stateParams.Filter.IdAtracao);

            atracaoSvc.listConveniencia({IdEstabelecimento: vm.Filter.IdEstabelecimento}).then(function (list) {
              if(list.length > 0)
                vm.atracaoList = list;
              else
                vm.atracaoList = null;

            });
          }else{
            vm.atracaoList = null;
          }
        }, true);

        vm.search = function (inScroll) {

          if(!vm.Filter.IdEstabelecimento) {
            vm.Filter.IdAtracao = null;
          }

          if (vm.searching) return;
          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

          vendaSiteSvc.getAll({
          Config: {
            Skip: vm.page,
              Top: 20
          },
          Filter: vm.Filter
        }).then(function (vendas) {
            vm.items = vm.items.concat(vendas);

            if (vendas.length < 20)
              vm.complete = true;

            if (vendas.length > 0)
              vm.page += 1;

            vm.searching = false;

        })}
        /*
        vm.search = function(inScroll) {

          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

          vm.QueryFilter.Config = { Skip: vm.page, Top: pageSize };
          vm.QueryFilter.Filter = vm.Filter;

          vendaSiteSvc.listOperacao(vm.QueryFilter)
            .then(function(data) {
              vm.items = vm.items.concat(data);

              if (data.length < pageSize)
                vm.complete = true;

              if (data.length > 0) {
                vm.page += 1;
              }

            }).finally(function() {
            vm.searching = false;
          });
        };
      */
        vm.detalhe = function (item) {
          $state.go('operacao.vendasite.form', {Id : item.IdVenda, Filter : vm.Filter})
        }
      }])

})();

/**
 * Created by thainan.gomes on 29/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendasite.form', [
      '$state',
      '$stateParams',
      '$filter',
      'common',
      'ticket.service.venda.vendasite',
      'ticket.service.programacao.vendaingresso',
      function ($state, $stateParams, $filter, common, vendaSiteSvc, vendaIngressoSvc) {
        var vm = common.controller.basic(this);

        vm.QtdTipoIngresso = "";

          if ($stateParams.Id != null) {

            vendaSiteSvc.getOperacao({IdVenda: $stateParams.Id}).then(function (data) {
              vm.item = data;
              vm.item.Assentos = vm.item.Assentos.substring(0,vm.item.Assentos.lastIndexOf(','))
            }).finally(function () {
              vm.searching = false;
            });

            vendaIngressoSvc.listvendaingressotroca({IdVenda: $stateParams.Id}).then(function (vendaIngressos) {

              var indexedTeams = [];
              vm.qtdTipoIngresso = "";

              vendaIngressos.map(function (itm) {
                var teamIsNew = indexedTeams.indexOf(itm.IdEstabelecimentoIngresso) == -1;
                if (teamIsNew) {
                  indexedTeams.push(itm.IdEstabelecimentoIngresso);
                }
              });

              var qtdList = indexedTeams.length;

              indexedTeams.map(function (itm, index) {
                var items = $filter('filter')(vendaIngressos, {'IdEstabelecimentoIngresso': itm});

                if ((index + 1) == qtdList) {
                  vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s)";
                } else {
                  vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s), ";
                }
              });
            });
          }

          vm.cancel = function () {
            $state.go('operacao.vendasite.grid', {Filter : $stateParams.Filter})
          }
      }])
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendasite',
      [
        '$scope',
        'common',
        'ticket.service.operacao.vendasite',
        function ($scope, common, vendaSiteSvc) {
          var vm = common.controller.master(this, vendaSiteSvc, $scope);
        }
      ]
    )
})();


(function() {
    'use strict';

    angular
        .module('ticket.controller.cliente', [

        ]);
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.cliente')
    .controller('ticket.controller.cliente.producao.grid', [
      'common',
      'ticket.service.cliente.producao',
      function (common, producaoSvc) {

        var vm = common.controller.grid(this, producaoSvc);

        vm.search();

        vm.item = {};

      }])

})();

/**
 * Created by thainan.gomes on 29/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.cliente')
    .controller('ticket.controller.cliente.producao.form', [
      '$state',
      '$stateParams',
      '$filter',
      'common',
      '$scope',
      '$rootScope',
      'ticket.service.cliente.producao',
      'ticket.service.controleregiao.cidade',
      function ($state, $stateParams, $filter, common,$scope,$rootScope, producaoSvc, cidadeSvc) {
        var vm = common.controller.form(this, producaoSvc);
        vm.loaded = loaded;
        vm.estadosList = vm.utils.Estados;

        setTimeout(function () {
          $scope.$watch('vm.item.UF', function () {

            if(vm.item.UF)
            {
              cidadeSvc.list({UF : vm.item.UF}).then(function (resp) {
                vm.cidadeList = resp;
              })
            }
          })
        },1000)

        function loaded() {
            if(vm.item.UF)
            {
              cidadeSvc.list({UF : vm.item.UF}).then(function (resp) {
                vm.cidadeList = resp;
              })
            }
        }

        vm.save = function () {
          producaoSvc.post(vm.item).then(function (resp) {
            vm.utils.ShowSuccess("Produção salva com sucesso!", "Operação realizada com sucesso!");
            $state.go('^.grid');
          })
        }

          vm.cancel = function () {
            $state.go('cliente.producao.grid', {Filter : $stateParams.Filter})
          }
      }])
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.cliente')
    .controller('ticket.controller.cliente.producao', [
      '$scope',
      'common',
      'ticket.service.cliente.producao',
      function ($scope, common, producaoSvc) {
        var vm = common.controller.master(this, producaoSvc, $scope);
      }])

})();


(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication', []);
})();


(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.controller.authentication.validar',
      ["$state", "common", "ticket.service.controleacesso.usuario",
      function($state, common, usuarioSvc) {
      var vm = common.controller.basic(this);

      vm.validado  = false;

        usuarioSvc.validar($state.params).then(function(res){
         vm.validado = true;
          vm.mensagem = "Seu email foi validado com sucesso. Em breve enviaremos um novo email.";

      }, function(res){
        vm.validado = false;
        if(res.data.erro){
          vm.mensagem = res.data.erro.Message || "token inválido";
        }else{
          vm.mensagem = "token inválido";
        }

      })

    }]);


})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.signup', [
          "$scope",
          "$state",
          "$http",
          "$filter",
          "common",
          "appSettings",
          "ticket.service.cliente.produtor",
          function(
            $scope,
            $state,
            $http,
            $filter,
            common,
            appSettings,
            produtorSvc){

          var vm = common.controller.instantiate(this);

            vm.user = {};

          // vm.user.Apelido = 'Elton';
          // vm.user.Login = 'zahnqgth@imgof.com';
          // vm.user.DataNascimento = '1985-04-08'
          // vm.user.Telefone = '21992185092';
          // vm.user.senha = '12345678';
          // vm.user.confirmarsenha = '12345678';

          vm.save = function () {

              if(vm.user.senha != vm.user.confirmarsenha) {
                vm.utils.ShowWarning("Atenção", "As senhas informadas não são iguais!");
                return;
              }

              vm.loading = true;
              vm.user.IdPerfil = appSettings.idPerfilCliente;
              produtorSvc.post(vm.user).then(function (resp) {
                vm.utils.ShowSuccess("Registro", "Cadastro realizado com sucesso!");
                vm.ok = true;
              }, function (resp) {
                console.log(resp);
              }).finally(function () {
                vm.loading = false;
              })
            }
            // vm.triSettings = triSettings;
            // vm.signupClick = signupClick;
            // vm.user = {
            //     name: '',
            //     email: '',
            //     password: '',
            //     confirm: ''
            // };
            //
            //
            //
            // ////////////////
            //
            // function signupClick() {
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .content($filter('triTranslate')('Confirmation sent'))
            //         .position('bottom right')
            //         .action($filter('triTranslate')('Login'))
            //         .highlightAction(true)
            //         .hideDelay(0)
            //     ).then(function() {
            //         $state.go('authentication.login');
            //     });
            // }
        }]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.controller.authentication.login', ["$state", "ticketSettings", "$scope", "common", "ticket.service.controleacesso.login",
      function($state, ticketSettings, $scope, common, loginSvc) {

        var vm = common.controller.instantiate(this);

        //SE ENTROU NESSE CONTROLLER, ENTÃO PERDE AS CREDENCIAIS.
        loginSvc.Logout(true);

        function loginClick() {
          vm.loading = true;
          loginSvc.Logon(vm.user)
            .then(function(v) {
                $state.go('site.home');
              },
              function(e) {
                if (e.data.error == "usuario_em_analise"){
                  vm.utils.ShowWarning("Atenção!", e.data.error_description);
                }
                else if (e.data.error == "email_unchecked"){
                  vm.utils.ShowWarning("Atenção!", e.data.error_description);
                }
                else if(e.data.error == "usuario_reprovado"){
                  vm.utils.ShowWarning("Atenção!", e.data.error_description);
                }
                else{
                    var msg = "Usuário/Senha incorretos. Verifique as informações e tente novamente.";
                    if (e.status == -1) {
                      msg = "Falha ao acessar o serviço. Verifique sua conexão com a internet."
                    }
                    vm.utils.ShowError("Identificação no sistema", msg);
                  }
              })
            .finally(function(e) {
              vm.loading = false;
            });
        }

        vm.onClickSignUp = function () {
          $state.go('auth.signup');
        }

        vm.loginClick = loginClick;
        vm.socialLogins = [{
          icon: 'fa fa-twitter',
          color: '#5bc0de',
          url: '#'
        }, {
          icon: 'fa fa-facebook',
          color: '#337ab7',
          url: '#'
        }, {
          icon: 'fa fa-google-plus',
          color: '#e05d6f',
          url: '#'
        }, {
          icon: 'fa fa-linkedin',
          color: '#337ab7',
          url: '#'
        }];
        vm.ticketSettings = ticketSettings;
        // create blank user variable for login form
        vm.user = {
          email: '',
          password: ''
        };





      }
    ]);


})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.lock', LockController);

    /* @ngInject */
    function LockController($state, triSettings) {
        var vm = this;
        vm.loginClick = loginClick;
        vm.user = {
            name: 'Morris Onions',
            email: 'info@oxygenna.com',
            password: ''
        };
        vm.triSettings = triSettings;

        ////////////////

        // controller to handle login check
        function loginClick() {
            // user logged in ok so goto the dashboard
            $state.go('triangular.dashboard-general');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.resetpassword', ["$q", "$state", "$stateParams", "common", "ticket.service.controleacesso.usuario", "ticket.service.controleacesso.login",  "ticketSettings", function($q, $state, $stateParams, common, usuarioSvc, loginSvc, ticketSettings){
            var vm = common.controller.basic(this) ;

            vm.user = {Password : '', Token: $stateParams.token};
            vm.pageTitle = $state.current.data.pageTitle;

            vm.loading = true;
            vm.err = false;
            vm.showFields = false;

            usuarioSvc.resetPasswordValidate($stateParams.token).then(
                function(res){                     
                    vm.showFields = true;
                },
                function(err){
                    vm.err = true;
                    var d = {Message: 'Ocorreu um erro ao acessar o serviço'}
                    var m = err.data || d;
                    vm.errMsg = m.Message || d.Message;
                }
            ).finally(function(){
                vm.loading = false;
            });
            
            vm.ComparaSenha = function(value){
              var def = $q.defer();
              
                if (value == vm.user.Password ) 
                {def.resolve(true);} 
                else 
                {def.reject(false);}

              return def.promise;
            };

            vm.Change = function(){ 
                vm.loading = true;
                usuarioSvc.resetPasswordConfirm( vm.user ).then(
                        function(res){  
                            vm.utils.ShowSuccess("Alteração de senha", "Sua senha foi alterada com sucesso.")
                            
                            loginSvc.Logon( { email: res.Login , password: vm.user.Password } ).then(function(v){ 
                                    ( v.estabelecimento == null ) ?  $state.go('auth.establishment') : $state.go('site.home');
                                }
                            );
                        },
                        function(e){  }
                    ).finally(function(){
                        vm.loading = false;
                    }); 
            }


        }]);

    
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.forgot', ["$state", "ticketSettings", "common", "ticket.service.controleacesso.captcha", "ticket.service.controleacesso.usuario", function ($state, ticketSettings, common, captchaSvc, usuarioSvc) {
            var vm = common.controller.instantiate(this);

            vm.ticketSettings = ticketSettings;
            vm.user = { Email: '' };
            
            vm.loadingCaptcha = true;
            vm.loadingError   = false;

            //busca um novo hash e renderiza o captcha que está associado.
            vm.reload = function(){
                vm.loadingError = false;
                
                return captchaSvc.get()
                    .then
                    (
                        function(v){ vm.user.Hash = v.Chave; },
                        function(err){ vm.ImgCaptcha = null; vm.loadingError = true; }
                    )
                    .finally
                    (
                        function(){ vm.loadingCaptcha = false; }
                    );
            }
            
            //renderiza o captcha 
            vm.renderCaptcha = function(){
                vm.loadingCaptcha = true;
                vm.loadingError = false;

                captchaSvc.render({Chave: vm.user.Hash})
                .then(
                    function(v){vm.ImgCaptcha = v;}, 
                    function(err){vm.reload();}
                )
                .finally(
                    function(){vm.loadingCaptcha = false;}
                );
            };
            
            vm.reseting = false;

            //Dispara o reinicio da senha
            vm.resetClick = function(){
                vm.reseting = true;                
                usuarioSvc.resetPassword(vm.user).then(
                    function(){ 
                        vm.utils.ShowSuccess("Recuperação de senha", "Enviamos as instruções para o seu e-mail.")
                        $state.go('auth.login') 
                    },
                    function(err){                         
                        vm.reload();
                    }
                ).finally(function(){
                    vm.reseting = false;
                });
            }


            vm.reload().then(function(){ vm.renderCaptcha(); });

        }]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.establishment', 
            ["$state", "ticketSettings", "common", "ticket.controleacesso.service.perfilestabelecimento", "ticket.service.controleacesso.login", 
            function($state, ticketSettings, common, estabelecimentoSvc, loginSvc){
                var vm = common.controller.instantiate(this);
                vm.estabelecimentos = [];
                vm.loading = true;

                estabelecimentoSvc.list({ }).then(
                    function(v)
                    {
                        vm.loading = false;
                        if( v.length == 0)
                            {$state.go('auth.login');}
                        else
                            {vm.estabelecimentos = v;}


                    },
                    function(e){
                        vm.loading = false;
                        vm.utils.ShowError("Seleção de estabelecimentos", 'Nenhum estabelecimento identificado. Refaça seu login.');
                        $state.go('auth.login');
                    }
                );


                vm.selecionar = function(itm){
                    loginSvc.RefreshToken(itm.IdEstabelecimento).then(
                        function(v){
                            vm.utils.ShowSuccess("Seleção de estabelecimentos", 'Estabelecimento selecionado: ' + v.estabelecimento)
                            $state.go('site.home');

                         },
                        function(err){
                            vm.utils.ShowError("Seleção de estabelecimentos", 'Ocorreu um erro na troca de estabelecimento.');
                            $state.go('auth.login');
                        }
                    );
                }


        }]);


})();

(function() {
  'use strict';

  angular
    .module('ticket.service.cliente', []);
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.cliente');

	mod.factory("ticket.service.cliente.produtor", ["common", "$http", function(common, $http){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "cliente/produtor/");
	}]);

})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.cliente');

	mod.factory("ticket.service.cliente.producao", ["common", function(common){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "cliente/producao/");
	}]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.translate', [
            'pascalprecht.translate',
            'LocalStorageModule'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.translate')
        .filter('ticketTranslate', appTranslateFilter);

    /* @ngInject */
    function appTranslateFilter($injector, $filter) {
        return function(input) {
            // if angular translate installed this will return true
            // so we can translate
            if($injector.has('translateFilter')) {
                return $filter('translate')(input);
            }
            else {
                // no translation active so just return the same input
                return input;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('ticket.translate')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig($translateProvider, $translatePartialLoaderProvider, appSettingsProvider) {
        var appLanguages = [
        {
            name: 'English',
            key: 'en'
        },
        {
            name: 'Portuguese',
            key: 'pt'
        }];

        /**
         *  each module loads its own translation file - making it easier to create translations
         *  also translations are not loaded when they aren't needed
         *  each module will have a i18n folder that will contain its translations
         */
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translatePartialLoaderProvider.addPart('app');

        // make sure all values used in translate are sanitized for security
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // cache translation files to save load on server
        $translateProvider.useLoaderCache(true);

        
        var angularTranslateLanguageKeys = [];
        for (var language in appLanguages) {
            angularTranslateLanguageKeys.push(appLanguages[language].key);

            appSettingsProvider.addLanguage({
                name: appLanguages[language].name,
                key: appLanguages[language].key
            });
        }

        /**
         *  try to detect the users language by checking the following
         *      navigator.language
         *      navigator.browserLanguage
         *      navigator.systemLanguage
         *      navigator.userLanguage
         */
        $translateProvider
        .registerAvailableLanguageKeys(angularTranslateLanguageKeys, {
            'en_US': 'en',
            'en_UK': 'en',
            'pt_BR': 'pt',
            'pt_PT': 'pt'
        })
        .use('pt');

        // store the users language preference in a cookie
        $translateProvider.useLocalStorage();
    }
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.venda', []);
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.service.venda')

    .factory("ticket.service.venda.vendasite", ["common", function (common) {
      var res = {
        listOperacao: function (filter) {
          return this.request("listOperacao", filter);
        },

        getOperacao: function (key) {
          return this.request("getOperacao", key);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/vendasite/");
    }]);

})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.service.venda')

    .factory("ticket.service.venda.venda", ["common", function (common) {
      var res = {}; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/venda/");
    }]);

})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.service.venda')

    .factory("ticket.service.venda.dashboard", ["common", function (common) {
      var res = {
        dashboarddetalhevendaspordiaprodutor: function (filter) {
          return this.request("dashboarddetalhevendaspordiaprodutor", filter);
        },
        dashboarddetalhevendasportipoingressoprodutor: function (filter) {
          return this.request("dashboarddetalhevendasportipoingressoprodutor", filter);
        },
        obterdashboard: function (filter) {
          return this.request("dashboard", filter);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/vendadashboard/");
    }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.programacao', []);
})();

/**
 * Created by thainan.gomes on 18/08/2017.
 */
(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.vendaingresso", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {

        listvendaingressotroca: function (filter) {
          return this.request("listvendaingressotroca", filter);
        }

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/vendaingresso/");
    }]);

})();


(function() {
  'use strict';

  angular
    .module('ticket.service.controleregiao', []);
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleregiao');

	mod.factory("ticket.service.controleregiao.cidade", ["common", function(common){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleregiao/cidade/");
	}]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.controleestabelecimento', []);
})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.estabelecimento", ["common", function(common) {
    var res = {

       ListByRegraIngressoEstabelecimento: function(filter){
       	 return this.request('ListByRegraIngressoEstabelecimento', filter);
       },

       ListLikeNome: function(filter){
         return this.request('listLikeNome', filter);
       },

      listgestao: function(filter){
        return this.request('listgestao', filter);
      }

    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/estabelecimento/");
  }]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.service.controleacesso', [ ]);
})();
(function(){
'use strict';

    angular.module("ticket.service.controleacesso")
    .factory("ticket.service.controleacesso.usuario", ["common", function( common ){
        var res = {
            getProfile: function () { return this.request("getprofile"); },
        	resetPassword: function(mdl){  return this.request("resetpassword", mdl); },
        	resetPasswordValidate: function(token){ return this.request("resetpasswordvalidate", {Token: token}); },
        	resetPasswordConfirm: function(mdl){ return  this.request("resetpasswordconfirm", mdl); },
        	checkRegisteredLogin:function (mdl) {  return  this.request("checkregisteredlogin", mdl, {supressError: true}); },
          reenviarEmail: function(mdl){  return this.request("resetpasswordAdmin", mdl); },
          validar:function(itm){
            return this.request("validar", itm);
          },

        };

        return common.service.instantiate(res, "controleacesso/usuario/");
    }]);
})();

(function(){
'use strict';

	angular.module("ticket.service.controleacesso")
	.factory("ticket.authentication.signup.service", ["$http", "$mdToast", "API_CONFIG", function($http, $mdToast, API_CONFIG ){

		return {};

	}]);

	

})();
(function () {
  'use strict';

  angular.module('ticket.service.controleacesso')
    .factory("ticket.controleacesso.service.perfilestabelecimento", 
    	['common', function(common){
    		var res = {};
    		return common.service.instantiate(res, "controleacesso/perfilestabelecimento/", res);
    }]);
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleacesso');

	mod.factory("ticket.service.controleacesso.perfil", ["common", function(common){
		var res = {
		  IsInRole: function(IdTela){
		    return this.request('isinrole', {IdFuncionalidade: IdTela});
      }
    }; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleacesso/perfil/");
	}]);

})();

(function(){

	angular.module("ticket.service.controleacesso")
	.factory("ticket.service.controleacesso.login", ["$http", "appSettings", "$rootScope", "$q", function($http, appSettings, $rootScope, $q ){

        var authData = null;



	    var svc = {
            CheckProfile: function (arr) {
                if (authData == null)
                    return false;
                else
                    return arr.indexOf(authData.profile) >= 0;
            },
            Logon: function (mdl) {
                var data = "grant_type=password&username=" + encodeURIComponent(mdl.email) + "&password=" + encodeURIComponent(mdl.password);
                var cfg = {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Basic ' + btoa(appSettings.appId + ':' + appSettings.appKey) },
                    xhrFields: { withCredentials: true }
                };
              var d = svc.Restore();
              if(d)
               var idEstabelecimento = d.id_estabelecimento;
                return $http.post( appSettings.auth,data, cfg)
                    .then(function (v) {
                        authData = v.data;
                        appSettings.setUserStore(authData);
                        $rootScope.$broadcast("app.logon", authData);
                        return authData;
                    },
                        function (e) {
                            svc.Logout(true);
                            return $q.reject(e);
                        }).finally(function(){
                          if(idEstabelecimento)
                            svc.RefreshToken(idEstabelecimento);
                        });
            },
            Logout: function (silence) {
                appSettings.clearUserStore();
                $rootScope.$broadcast("app.logoff");
            },
            RefreshToken: function (IdEstabelecimento) {
                IdEstabelecimento = IdEstabelecimento || '';
                var d = svc.Restore();

                if (d == null || d.access_token == null)
                    return $q.reject("Não autenticado");
                else
                {
                    appSettings.clearUserStore();
                    $rootScope.$broadcast("app.logoff");

                    return $http({
                        method: 'POST',
                        url: appSettings.auth,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                        data: $.param({
                            grant_type: 'refresh_token',
                            refresh_token: d.refresh_token,
                            client_id: appSettings.appId,
                            client_secret : appSettings.appKey,
                            estab_id: IdEstabelecimento
                        })
                    }).then(
                        function (v) {
                            if (v.status == 200) {
                                authData = v.data;
                                appSettings.setUserStore(authData);
                                $rootScope.$broadcast("app.logon", authData);
                                return authData;
                            }
                        },
                        function(err){
                            //svc.Logout(true);
                            return $q.reject("Falha na autenticação automática");
                        });
                }
            },
            Restore: function () {

                if (!authData)
                    authData = appSettings.getUserStore();

                if (authData == null || authData.access_token == null)
                    return null;
                else
                    return authData;
            }
        };


        return svc;


	}]);



})();

(function(){

	angular.module("ticket.service.controleacesso")
	.factory("ticket.service.controleacesso.captcha", ["common", function( common ){
		

			var res = {
					get : function(key){ return this.request(  "get", key);  },
					render: function(key){return this.request( "render", key);  }
			   }

			return common.service.basic(res, "controleacesso/captcha/");

		}

	]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo', []);
})();
(function() {
  'use strict';

  angular.module('ticket.service.conteudo')

  .factory("ticket.service.conteudo.atracao", [
    "common",
    "Upload",
    "ticket.service.controleacesso.login",
    "appSettings",
    "$http",
    "$q",
    function(common, Upload, loginSvc, appSettings, $http, $q) {

      var res = {

        listFuturas: function (filter) {
          return this.request("listFuturas", filter);
        },

        getAllGestao: function(filter) {
          return this.request("getallgestao", filter);
        },

        uploadVideoGestao: function(file) {
          if (!file) return;

          var fd = new FormData();

          fd.append("file", file);

          var def = $q.defer();

          $http.post(appSettings.url + "controleconteudo/atracao/UploadVideo", fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              },
              uploadEventHandlers: {
                progress: function(e) {
                  def.notify(e);
                }
              }
            })
            .then(
              function(resp) {
                def.resolve(resp);
              },
              function(err) {
                def.reject(err);
              }
            );

          return def.promise;
        },

        uploadVideo: function(itm) {

          var fd = new FormData();

          fd.append("file", itm.file[0]);

          var def = $q.defer();

          $http.post(appSettings.url + "controleconteudo/atracao/UploadVideo", fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              },
              uploadEventHandlers: {
                progress: function(e) {
                  def.notify(e);
                }
              }
            })
            .then(
              function(resp) {
                def.resolve(resp);
              },
              function(err) {
                def.reject(err);
              }
            );

          return def.promise;
        },

        // uploadImagem: function (imageBase64) {
        //   return this.request("UploadImage", imageBase64);
        // },

        uploadImagem: function(imageBase64) {

          return $http.post(appSettings.url + "controleconteudo/atracao/UploadImage", imageBase64)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        deleteImagem: function(imagem) {

          //var Imagem = { Nome: imagem };

          return $http.post(appSettings.url + "controleconteudo/atracao/DeleteImage", imagem)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        save: function(NovaAtracao) {

          var Atracao = {
            Nome: NovaAtracao.FichaTecnica.Nome,
            IdAtracao: NovaAtracao.Atracao.IdAtracao,
            FilaFraude: true,
            IdTipoAtracao: NovaAtracao.Atracao.IdTipoAtracao,
            Ativo: true,
            User: ''
          }

          var AtracaoEstabelecimento = {};

          var Generos = NovaAtracao.FichaTecnica.Generos;
          var Inadequacoes = NovaAtracao.FichaTecnica.Inadequacoes;
          var Participantes = NovaAtracao.Participantes;
          var Banda = NovaAtracao.Banda;

          var AtracaoVersao = {
            NomeHistorico: NovaAtracao.FichaTecnica.Nome,
            NomeOriginal: NovaAtracao.FichaTecnica.NomeOriginal,
            IdClassificacao: NovaAtracao.FichaTecnica.IdClassificacao,
            Sinopse: NovaAtracao.Sinopse.Texto,
            Duracao: NovaAtracao.FichaTecnica.Duracao,
            PaisOrigem: NovaAtracao.FichaTecnica.PaisOrigem,
            IdiomaOriginal: NovaAtracao.FichaTecnica.IdiomaOriginal,
            UrlOficial: NovaAtracao.FichaTecnica.UrlOficial,
            AnoLancamento: NovaAtracao.FichaTecnica.AnoLancamento,
            DataEstreia: NovaAtracao.FichaTecnica.DataEstreia,
            Uri: "Uri",
            Status: "",
            User: ""
          }

          var AtracaoArquivo = NovaAtracao.Midia.AtracaoArquivo;

          return this.request("post", {
            IdEstabelecimento: NovaAtracao.IdEstabelecimento,
            Atracao: Atracao,
            Generos: Generos,
            Inadequacoes: Inadequacoes,
            Participantes: Participantes,
            Bandas: Banda,
            AtracaoVersao: AtracaoVersao,
            AtracaoEstabelecimento: AtracaoEstabelecimento,
            AtracaoArquivo: AtracaoArquivo
          });
        },

        listConveniencia: function(filter) {
          return this.request("listconveniencia", filter);
        },

        listAtracaoProgramacao: function(filter) {
          return this.request("listatracaoprogramacao", filter);
        }

      }; //<-- Customize aqui seu service

      //return res;

      return common.service.instantiate(res, "controleconteudo/atracao/");
    }
  ]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.site')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, menuProvider) {

        $stateProvider
        .state('site', {
            abstract: true,
            url: '/site',
            templateUrl: "view/site/_content.html"
        })
        .state('site.home', {
            data: {
              displayName: 'Home'
            },
            parent: 'site',
            url: '/home',
            templateUrl: 'view/site/home/index.html',
            controller:  'ticket.controller.site.home',
            controllerAs: 'vm'
        })
          .state('site.detalhe', {
            url: '/detalhe/:IdSessao',
            data: { displayName: 'Detalhe' },
            templateUrl: 'view/site/home/detalhe.html',
            controller:  'ticket.controller.site.detalhe',
            controllerAs: 'vm',
            params: {
              IdSessao: null
            }
          })
        // .state('ticket.user-home', {
        //     templateUrl: 'view/site/home/index.html',
        //     controller: function($state){ $state.go('site.home') },
        //     controllerAs: 'vm'
        // })


        menuProvider.left.add(
            {
                name: 'Home',
                icon: 'fa fa-home',
                type: 'group',
                priority: 1.0,
                state: 'site.home',
                childs:[
                    {
                        name: 'Home',
                        icon: 'fa fa-home',
                        type: 'link',
                        priority: 1.0,
                        state: 'site.home'/*,
                        data: { permissions: { only: ['site.user-home'] } }*/
                    },
                 ]
            }

        );

        menuProvider.left.add({
            type: 'divider',
            priority: 1.1
        });
    }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {
    $stateProvider
      .state('operacao', {
        abstract: true,
        url: '/operacao',
        templateUrl: "view/site/_content.html"
      })

     .state('operacao.vendasite', {
        data: {
          displayName: 'Venda Site'
        },
        abstract: true,
        parent: 'operacao',
        url: '/vendasite',
        templateUrl: 'view/operacao/venda/vendasite/index.html',
        controller: 'ticket.controller.operacao.vendasite',
        controllerAs: 'vm'
      })

      .state('operacao.vendasite.grid', {
        data: {
          displayName: 'Venda Site'
        },
        parent: 'operacao',
        url: '/vendasite/ultimas-vendas',
        params: {
          Filter: null
        },
        templateUrl: 'view/operacao/venda/vendasite/grid.html',
        controller: 'ticket.controller.operacao.vendasite.grid',
        controllerAs: 'vm'
      })

      .state('operacao.vendasite.form', {
        data: {
          displayName: 'Detalhe Venda Site'
        },
        parent: 'operacao',
        url: '/vendasite/detalhe/:Id',
        params: {
          Id: null,
          Filter: null
        },
        templateUrl: 'view/operacao/venda/vendasite/form.html',
        controller: 'ticket.controller.operacao.vendasite.form',
        controllerAs: 'vm'
      })

    // menuProvider.left.add({
    //   name: 'Operação',
    //   icon: 'fa fa-music',
    //   type: 'link',
    //   priority: 1.0,
    //   state: 'operacao',
    //   childs:
    //   [
    //     {
    //       second:true,
    //       name: 'Últimas Vendas',
    //       icon: 'fa fa-music',
    //       type: 'link',
    //       priority: 1.0,
    //       state: 'operacao.vendasite.grid'
    //     }
    //   ]
    // });
    //
    // menuProvider.left.add({
    //   type: 'divider',
    //   priority: 1.1
    // });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.cliente')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {
    $stateProvider
      .state('cliente', {
        abstract: true,
        url: '/cliente',
        templateUrl: "view/site/_content.html"
      })

     .state('cliente.producao', {
        data: {
          displayName: 'Producao'
        },
        abstract: true,
        parent: 'cliente',
        url: '/producao',
        templateUrl: 'view/cliente/producao/index.html',
        controller: 'ticket.controller.cliente.producao',
        controllerAs: 'vm'
      })

      .state('cliente.producao.grid', {
        data: {
          displayName: 'Produções'
        },
        parent: 'cliente.producao',
        url: '/grid',
        params: {
          Filter: null
        },
        templateUrl: 'view/cliente/producao/grid.html',
        controller: 'ticket.controller.cliente.producao.grid',
        controllerAs: 'vm'
      })

      .state('cliente.producao.form', {
        data: {
          displayName: 'Cadastro'
        },
        parent: 'cliente.producao',
        url: '/form/:IdProducao',
        params: {
          IdProducao: null
        },
        templateUrl: 'view/cliente/producao/form.html',
        controller: 'ticket.controller.cliente.producao.form',
        controllerAs: 'vm'
      })

    menuProvider.left.add({
      name: 'Produção',
      icon: 'fa fa-edit',
      type: 'link',
      priority: 1.0,
      state: 'cliente',
      childs:
      [
        {
          second:true,
          name: 'Cadastro',
          icon: 'fa fa-edit',
          type: 'link',
          priority: 1.0,
          state: 'cliente.producao.grid'
        }
      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .run(["$rootScope", "$state", "ticket.service.controleacesso.login", function($rootScope, $state, loginSvc){
    
            // create roles for app
            //RoleStore
            //.defineRole('GESTÃO', ['site.user-home', 'conteudo.atracao', 'conteudo.atracao.nova', 'conteudo.atracao.nova-wizard'], checkRole);
            

            ///////////////////////

            // default redirect if access is denied
            function accessDenied() {
                $state.go('401');
            }

            // function that calls user service to check if permission is allowed
            function checkRole(permission, transitionProperties) {
                return loginSvc.hasPermission(permission, transitionProperties);
            }

            // watches

            // redirect all denied permissions to 401
            var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

            // remove watch on destroy
            $rootScope.$on('$destroy', function() {
                deniedHandle();
            });
        }]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, menuProvider) {

        $stateProvider
        .state('auth', {
            abstract: true,
            templateUrl: "view/authentication/_content.html"
        })
        .state('auth.login', {
            url: '/login',
            templateUrl: 'view/authentication/login/login.html',
            controller:  'ticket.controller.authentication.login',
            controllerAs: 'vm',
            data: { pageTitle: 'Login', specialClass: 'gray-bg' }
        })
        .state('auth.validar', {
            url: '/validar/:token',
            templateUrl: 'view/authentication/signup/validar.html',
            controller: 'ticket.controller.authentication.validar',
            params: {token: null},
            controllerAs: 'vm'
          })
        .state('auth.forgot', {
            url: '/forgot',
            templateUrl: 'view/authentication/forgot/forgot.html',
            controller: 'ticket.controller.authentication.forgot',
            controllerAs: 'vm'
        })
        .state('auth.resetpassword', {
            url: '/resetpassword/:token',
            templateUrl: 'view/authentication/forgot/reset.html',
            controller: 'ticket.controller.authentication.resetpassword',
            controllerAs: 'vm',
            data: { pageTitle: 'Recuperação de senha' }
        })
        .state('auth.lock', {
            url: '/lock',
            templateUrl: 'app/authentication/lock/lock.tmpl.html',
            controller: 'ticket.controller.authentication.lock',
            controllerAs: 'vm'
        })
        .state('auth.establishment', {
            url: '/establishment',
            templateUrl: 'view/authentication/establishment/index.html',
            controller: 'ticket.controller.authentication.establishment',
            controllerAs: 'vm'
        })
        .state('auth.setpassword', {
            url: '/setpassword/:token',
            templateUrl: 'view/authentication/forgot/reset.html',
            controller: 'ticket.controller.authentication.resetpassword',
            controllerAs: 'vm',
            data: { pageTitle: 'Definir senha',  }
        })
          .state('auth.signup', {
            url: '/signup',
            templateUrl: 'view/authentication/signup/signup.html',
            controller:  'ticket.controller.authentication.signup',
            controllerAs: 'vm',
            data: { pageTitle: 'Login', specialClass: 'gray-bg' }
          })      ;



    }
})();

(function() {
  'use strict';

  angular
    .module("ticket", ['app', 'app.directive', 'ticket.translate', 'ticket.service', 'ticket.controller', 'ticket.filter'])
})();
(function() {
    'use strict';

    angular
        .module('ticket')
        .provider('ticketSettings', settingsProvider);

    /* @ngInject */
    function settingsProvider() {
        // Provider
        var settings = {
            name: 'Divertix',
            logo: 'fa fa-ticket',
            copyright: '',
            version: ''
        };

        this.setLogo = setLogo;
        this.setName = setName;
        this.setCopyright = setCopyright;
        this.setVersion = setVersion;


        function setLogo(logo) {
            settings.logo = logo;
        }

        function setName(name) {
            settings.name = name;
        }

        function setCopyright(copy) {
            settings.copyright = copy;
        }

        function setVersion(version) {
            settings.version = version;
        }

        // Service
        this.$get = function() {
            return {
                name: settings.name,
                copyright: settings.copyright,
                logo: settings.logo,
                version: settings.version,
                defaultSkin: settings.defaultSkin
            };
        };
    }
})();

(function() {
  'use strict';

  angular
    .module('ticket.service', [
      'ticket.service.controleacesso',
      'ticket.service.programacao',
      'ticket.service.venda',
      'ticket.service.controleestabelecimento',
      'ticket.service.conteudo',
      'ticket.service.cliente',
      'ticket.service.controleregiao',
    ]);
})();

(function() {
  'use strict';
  angular
    .module('inspinia', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toaster', 'ui.mask', 'ngFileUpload', 'oc.lazyLoad', 'ticket', 'ui.utils.masks', 'multipleDatePicker', 'tableSort', 'infinite-scroll', 'ngImgCrop','ngjsColorPicker','textAngular','ta-maxlength', 'chart.js', 'angular.filter', 'angular-linq'])


  //Override module dependecy config
  .value('THROTTLE_MILLISECONDS', 2000);
})();

'use strict';

angular.module('inspinia')
  .controller('MainController', function () {

    var vm = this;

    vm.userName = 'Example user';
    vm.helloText = 'Welcome in INSPINIA Gulp SeedProject';
    vm.descriptionText = 'It is an application skeleton for a typical AngularJS web app. You can use it to quickly bootstrap your angular webapp projects.';

  });

(function() {
    'use strict';

    angular
        .module('ticket.filter', [
          'ticket.filter'
    ]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.filter')
        .filter('time', timeFilter);

    /* @ngInject */
    function timeFilter($filter) {
      return function(input)
      {
        if(input == null){ return ""; }

        var _date = $filter('date')(new Date(input), 'HH:mm');

        return _date;

      };
    }
})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "AM",
        "PM"
      ],
      "DAY": [
        "domingo",
        "segunda-feira",
        "ter\u00e7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "antes de Cristo",
        "depois de Cristo"
      ],
      "ERAS": [
        "a.C.",
        "d.C."
      ],
      "FIRSTDAYOFWEEK": 6,
      "MONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "SHORTDAY": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\u00e1b"
      ],
      "SHORTMONTH": [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "STANDALONEMONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d 'de' MMM 'de' y HH:mm:ss",
      "mediumDate": "d 'de' MMM 'de' y",
      "mediumTime": "HH:mm:ss",
      "short": "dd/MM/yy HH:mm",
      "shortDate": "dd/MM/yy",
      "shortTime": "HH:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "R$",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\u00a4",
          "negSuf": "",
          "posPre": "\u00a4",
          "posSuf": ""
        }
      ]
    },
    "id": "pt-br",
    "localeID": "pt_BR",
    "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function() {
    'use strict';

    angular
        angular.module("app.directive", []);
})();
(function () {
  angular.module('app.directive')
    .directive('readMore', function () {
      return {
        restrict: 'A',
        transclude: true,
        replace: true,
        template: '<p></p>',
        scope: {
          moreText: '@',
          lessText: '@',
          words: '@',
          ellipsis: '@',
          char: '@',
          limit: '@',
          content: '@'
        },
        link: function (scope, elem, attr, ctrl, transclude) {
          var moreText = angular.isUndefined(scope.moreText) ? ' <a class="read-more">Ver mais</a>' : ' <a class="read-more">' + scope.moreText + '</a>',
            lessText = angular.isUndefined(scope.lessText) ? ' <a class="read-less">Ocultar</a>' : ' <a class="read-less">' + scope.lessText + '</a>',
            ellipsis = angular.isUndefined(scope.ellipsis) ? '' : scope.ellipsis,
            limit = angular.isUndefined(scope.limit) ? 80 : scope.limit;

          attr.$observe('content', function (str) {
            readmore(str);
          });

          transclude(scope.$parent, function (clone, scope) {
            readmore(clone.text().trim());
          });

          function readmore(text) {

            var text = text,
              orig = text,
              regex = /\s+/gi,
              charCount = text.length,
              wordCount = text.trim().replace(regex, ' ').split(' ').length,
              countBy = 'char',
              count = charCount,
              foundWords = [],
              markup = text,
              more = '';

            if (!angular.isUndefined(attr.words)) {
              countBy = 'words';
              count = wordCount;
            }

            if (countBy === 'words') { // Count words

              foundWords = text.split(/\s+/);

              if (foundWords.length > limit) {
                text = foundWords.slice(0, limit).join(' ') + ellipsis;
                more = foundWords.slice(limit, count).join(' ');
                markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
              }

            } else { // Count characters

              if (count > limit) {
                text = orig.slice(0, limit) + ellipsis;
                more = orig.slice(limit, count);
                markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
              }

            }

            elem.append(markup);

            elem.find('.read-more').show();
            elem.find('.more-text').hide().removeClass('show');
            
            elem.find('.read-more').on('click', function () {
              $(this).hide();
              elem.find('.more-text').addClass('show').slideDown();
            });
            elem.find('.read-less').on('click', function () {
              elem.find('.read-more').show();
              elem.find('.more-text').hide().removeClass('show');
            });

          }
        }
      };
    });
})();
(function() {

  //TIPOS DE INPUTS

  /*

  1 - select
   options -  Array (Utilizado para fazer o bind)
   valueField - Usado quando o identificar for diferente de "Id"
   textField -  Usado quando o texto for diferente de "Nome"

  2 - number
   number|{int} - Total de casas decimais. (Default = "0")
   maxlength={int} - Quantidade máxima de caracteres que o usuário poderá digitar.



    */

  angular.module("app.directive")
    .directive('ngField', ['$compile', function($compile) {

      function getTemplate(scope, elm) {
        var engines = {
          date: 'uib-datepicker-popup="dd/MM/yyyy" ',
          cpf: ' ng-cpf ',
          cnpj: ' ng-cnpj ',
          cep: 'ng-cep',
          text: ''
        };
        var masks = {
          cpf: '999.999.999-99',
          cnpj: '99.999.999/9999-99',
          cep: '99.999-999'
        };
        var patterns = {
          email: '/^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,}$/'
        };

        var required = (scope.required) ? ' ng-required="true" ' : '';

        var pattern = (patterns[scope.type]) ? ' ng-pattern="' + patterns[scope.type] + '" ' : "";

        var $frm = elm.closest('form');
        scope.form = ($frm.length == 0 || $frm.attr("name") == "" || $frm.attr("name") == null) ? 'frm' : $frm.attr("name");
        scope.name = scope.name || "txt_" + elm.index();

        var flagPopup = scope.name + '_popup';

        scope.valueField = scope.valueField || 'Id';
        scope.textField = scope.textField || 'Nome';
        var diretiveDisabled =  ' ng-disabled="ngDisabled" ';

        var maxlength = scope.maxlength != null ? ' maxlength="{{maxlength}}"' : '';
        scope.ngDisabled = scope.ngDisabled || false;

        var rows = scope.rows != null ? 'rows= {{rows}}' : 'rows=4';

        var htmlTooltip = scope.tooltip != null ? '<span class="input-group-addon btn btn-primary" style="border-color:#ccc; background-color:white!important" popover-placement="auto top"  uib-popover="{{tooltip}}" popover-trigger="mouseenter"><i class="fa fa-question-circle" style="color:black" aria-hidden="true"></i></span>' : '';

        var res = '';

        if ($frm.length == 0) {
          res += '    <span class="help-block">Elemento de formulário não encontrado.</span>';
        } else {
          res =
            '<ng-form name={{form}}>' +
            ' <div class="form-group form-group-sm ">' +
            '    <h4 class="text-bold text-left">{{label}}</h4>' +
            '    <div ng-class="{\'has-success\':(' + scope.form + '.' + scope.name + '.$valid && !' + scope.form + '.' + scope.name + '.$pending && !loading), \'has-error\':(!' + scope.form + '.' + scope.name + '.$valid && !' + scope.form + '.' + scope.name + '.$pending && !loading) }">';

          if (scope.type == 'select') {
            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '      <select ' + diretiveDisabled + ' class="form-control" aria-label="{{label}}" ' + maxlength + ' ng-model="model" name="' + scope.name + '" ' + required + '  validate-async="validateAsync" ng-field-validator  >' +
              '<option></option>' +
              '        <option ng-repeat="o in options" value="{{o.' + scope.valueField + '}}">{{o.' + scope.textField + '}}</option>' +
              '      </select>' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'date') {
            scope.dateOptions = {
              minDate: scope.minDate,
              'class': 'datepicker'
            };
            res += '<div class="input-group">' +
              '<input ' + diretiveDisabled + ' type="text" class="form-control" aria-label="{{label}}" ng-model="model" name="' + scope.name + '" ' + required + ' uib-datepicker-popup="dd/MM/yyyy" show-button-bar="false" datepicker-options="dateOptions" is-open="' + flagPopup + '" />' +
              '<span class="input-group-btn">' +
              '<button type="button" class="btn btn-sm btn-success" ng-click="' + flagPopup + '=true;">' +
              '<i class="glyphicon glyphicon-calendar"></i>' +
              '</button>' +
              '</span>' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'time') {

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" ui-time-mask="short" class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'phone') {

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" ui-br-phone-number class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'password') {
            res += '      <input ' + diretiveDisabled + ' type="password" class="form-control" aria-label="{{label}}" ' + maxlength + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />';
          } else if (scope.type == 'textarea') {
            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<textarea ' + rows + ' ' + diretiveDisabled + 'name="' + scope.name + '" class="form-control" ng-model="model"' + maxlength + required + ' style="resize:none"></textarea>' +
              htmlTooltip +
              '</div>';
          } else {
            var format = "";

            if (scope.type != null) {
              var arr = scope.type.split('|');

              if (arr[0] == "number") {
                format = (arr.length == 1) ? "ui-hide-group-sep ui-number-mask='0'" : "ui-hide-group-sep ui-number-mask='" + arr[1] + "'"
              } else if (arr[0] == "cpf")
                format = "ui-br-cpf-mask";
              else if (arr[0] == "percentual")
                format = (arr.length == 1) ? "ui-percentage-mask" : "ui-percentage-mask='" + arr[1] + "'"
              else if (arr[0] == "money")
                format = (arr.length == 1) ? "ui-money-mask" : "ui-money-mask='" + arr[1] + "'"
              else if (arr[0] == "cnpj")
                format = (arr.length == 1) ? "ui-br-cnpj-mask" : "ui-br-cnpj-mask='" + arr[1] + "'"
              else if (arr[0] == "cep")
                format = (arr.length == 1) ? "ui-br-cep-mask" : "ui-br-cep-mask='" + arr[1] + "'"

            }

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model"  name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          }

          if (scope.validateSubmit === undefined) {

            res += '    </div>' +
              '    <span class="help-block" ng-show="' + scope.form + '.' + scope.name + '.$error.required">Preenchimento obrigatório</span>' +
              '    <span class="help-block" ng-show="' + scope.name + '.$error.pattern">Formato inválido</span>' +
              '    <span class="help-block" ng-show="' + scope.name + '.$error.custom">{{validateAsyncError}}</span>' +
              ' </div> ' +
              '</ng-form>';
          } else {
            res += '    </div>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.form + '.' + scope.name + '.$error.required">Preenchimento obrigatório</span>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.name + '.$error.pattern">Formato inválido</span>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.name + '.$error.custom">{{validateAsyncError}}</span>' +
              ' </div> ' +
              '</ng-form>';
          }


        }

        return res;
      }

      return {
        restrict: 'E',
        //label - título do campo, form: nome do form que o campo pertence, name: nome usado pelo js, model: model :), type: email, cpf, data, etc., required : obrigatoriedade, mask: máscara de formatação (type costuma ter sua formatação implicita), validate: função que recebe o valor e evento do campo e retorna bool que será aplicado na validação, validateAsync: retorna um promise onde function(modelValue, viewValue) {return $http.post(url)}
        scope: {
          changed: '=?',
          label: '@label',
          name: '@name',
          model: '=?',
          ngDisabled: "=?",
          maxlength: "=",
          tooltip: "@tooltip",
          rows: '=',
          type: '@type',
          required: '@',
          mask: '@mask',
          validate: '=?',
          validateAsync: '=?',
          validateAsyncError: '@',
          loading: '=',
          pattern: '@',
          size: '@',
          options: '=',
          valueField: '@',
          textField: '@',
          options: '=',
          valueField: '@',
          textField: '@',
          maskPercentual: '@',
          minDate: '=',
          validateSubmit: '=?'
        },
        link: function(scope, elm, attrs) {

          var htm = getTemplate(scope, elm);
          elm.html(htm).show();
          $compile(elm.contents())(scope);


          scope.$watch('model', function() {
            if (scope.type == 'date' && typeof(scope.model) === "string")
              scope.model = new Date(scope.model);
            else if (scope.type == 'select' && typeof(scope.model) != "string" && scope.model !== undefined && scope.model != null)
              scope.model = scope.model.toString();

            if(scope.changed && scope.changed())
            {
              scope.changed()();
            }

          });
        }
      };
    }])

    .directive('ngFieldValidator', ['$compile', function($compile) {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          validate: '&',
          validateAsync: '=?'
        },
        link: function(scope, elm, attrs, ngModel) {
          if (ngModel && scope.validateAsync)
            ngModel.$asyncValidators.custom = scope.validateAsync;
        }
      };
    }]);

})();

(function () {
angular.module("app.directive")
  .directive('ngEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  });
})
();

(function() {
  angular.module("app.directive")
    .directive('ngSvg', [function() {
      return {
        restrict: 'E',
        scope: {
          content: '=',
          loaded: '&',
          'class': '@',
          width: '@',
          height: '@',
          mouseover: '&'
        },
        link: function(scope, elm, attrs) {

          var chgSize = function($svg) {
            if (scope.width && scope.width != '')
              $svg.attr('width', scope.width);

            if (scope.height && scope.height != '')
              $svg.attr('height', scope.height);
          }


          scope.$watch("content", function() {
            elm.html('');
            if (scope.content) {
              elm.html(scope.content);
              elm.attr('ng-mouseover', scope.mouseover);
              if (scope.loaded())
                scope.loaded()(elm.find('svg'));

            }

          });
          scope.$watch("width", function() {
            chgSize(elm.find('svg'));
          });
          scope.$watch("height", function() {
            chgSize(elm.find('svg'));
          });
        }
      };

    }])
    .directive('svgLoading', [function() {
      return {
        restrict: 'E',
        template: '<svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring svg-purple-color"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="163.36281798666926 87.9645943005142" stroke="#d25353" fill="none" stroke-width="20"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>'
      };
    }]);

})();
(function () {

    angular.module("app.directive")
.directive('icheck', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, element, $attrs, ngModel) {
            return $timeout(function () {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function (newValue) {
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-orange',
                    radioClass: 'iradio_square-orange'

                }).on('ifChanged', function (event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                        $scope.$apply(function () {
                            return ngModel.$setViewValue(event.target.checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                        return $scope.$apply(function () {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    };
});
})();
(function () {

  angular.module("app.directive")
    .directive('chips', function () {
      return {
        restrict: 'E',
        scope: {
          tags: '=',
          selecionado: '=',
          autocomplete: '=autocomplete',
          placeholder: '@',
          valueField: '@',
          textField: '@',
          iconField: '@',
          max: '@', //Quantidade de itens que poderão ser adicionado ao chip
          disabled: '=', // Se 'true' desabilita o chip
          hasImage: '=', //Se definido como 'false', o chips não terá imagem, default 'true'
          allowNewItem: '=', // Se definido como 'false', o chip não permitirá a inclusão de novo item, default 'true'.
          selectedItemChange: '=?',
          items: '=?',
          removed:'=?',
          hasCheck: '=',
          enterNew: '='
        },
        template: '<div class="tags">' +
        '<div ng-repeat="t in tags" class="tag">' +
        '<img src="{{t[iconField]}}" fallback-src="../img/user_32x32.png" ng-if="t[iconField] != undefined" ng-hide="{{hasImage}}">&nbsp;' +
        '<img src="../img/user_32x32.png" ng-if="t[iconField] == undefined" ng-show="{{hasImage == false ? false : true}}"></img>' +
        '<span style="line-height: 30px;margin-left: 5px;">{{t[textField]}} </span> <b  class="badge badge-danger" ng-if="t[valueField]==null">Novo</b>&nbsp;&nbsp' +
        '<a class="close" ng-click="remove($index, t)" ng-hide="{{disabled}}">' +
        '<i class="fa fa-times-circle fa-5x" style="margin-top: 5px" aria-hidden="true"></i></a>' +
        '<input ng-if="hasCheck" icheck name="{{optName}}" type="radio" ng-model="$parent.$parent.selecionado" ng-value="t[valueField]" />'+
        '</div>' +
        '</div>' +
        '<div class="input-form">' +
        '<input type="text" id="txtBusca" class="form-control" placeholder="{{placeholder}}" ng-disabled="disabled" ng-model="newValue" /> '+
        '<div class="text-danger" ng-if="limiteAlcancado"><strong>O limite de chips foi alcançado.</strong></div>' +
        '<h4 class="text-primary" ng-if="enterNew"><small>Pressione a tecla "ENTER" para incluir um novo registro.</small></h4>',
        // '<div class="progress progress-striped active" style="height: 4px;margin-top: -5px;">' +
        // '<div style="width:{{progress}}%" class="progress-bar progress-bar-success">' +
        // '</div>' +
        // '</div>',

        // '<span class="input-group-btn"><a class="btn btn-default" ng-click="add()">Add</a></span></div>',
        link: function ($scope, $element) {
          $scope.optName    =  "opt_" + Math.floor((1 + Math.random()) * 0x10000).toString(16)
          $scope.valueField = $scope.valueField || 'Id';
          $scope.textField = $scope.textField || 'Nome';
          $scope.iconField = $scope.iconField || '';

          var max = $scope.max;
          var input = angular.element($element).find('#txtBusca');

          $scope.autocompleteFocus = function (event, ui) {

            //input.val(ui.item[$scope.textField]);

            return false;
          };

          $scope.autocompleteSelect = function (event, ui) {
            $scope.newValue = ui.item[$scope.textField];

            if ($scope.selectedItemChange != undefined)
              $scope.selectedItemChange(ui);

            $scope.$apply(function () {
              $scope.add(ui.item)
            });

            return false;
          };

          $scope.progress = 0;

          $($element).find('#txtBusca').autocomplete({
            minLength: 0,

            source: function (req, resp) {

              $scope.items(req.term).then(function (data) {
                return resp(data);
              }).finally(function () {
                $scope.progress = 0;
              });
            },

            focus: (function (_this) {

              return function (event, ui) {

                return $scope.autocompleteFocus(event, ui);
              };
            })(this),

            select: (function (_this) {
              return function (event, ui) {

                return $scope.autocompleteSelect(event, ui);
              };
            })(this)

          }).autocomplete("instance")._renderItem = function (ul, item) {
//            maxShowItems: 5;

            var $li = $('<li>');
            $li.attr("data-id", item[$scope.valueField])
            var $div = $('<div>');
            var $img = $('<img>');
            var $a = $('<a>');

            if (item[$scope.iconField] != undefined) {
              $img.attr({
                src: item[$scope.iconField],
                alt: item[$scope.textField],
                'fallback-src' : '../img/user_32x32.png'
              });
              $a.append($img);
            }
            else {
              $a.append('<img src="../img/user_32x32.png"> </img>');
            }

            $a.append(item[$scope.textField]);
            $div.append($a);
            $li.append($div);
            ul.addClass("chips");

            $img.error(function() {
//              $(this).attr("src", "https://www.google.com/images/srpr/logo3w.png");
              $(this).attr("src", "../img/user_32x32.png");
            })

            return $li.appendTo(ul);
          }

          $scope.add = function (itm) {
            if ($scope.tags.length == max) {
              $scope.limiteAlcancado = true;
              input.attr('disabled', true);
              $scope.newValue = "";
              input.val('');
            }

            if ($scope.allowNewItem != false || $scope.allowNewItem == undefined || itm[$scope.valueField] != undefined) {
              if ($scope.tags.length < max || max == undefined) {
                if ($scope.tags.filter(function (item) {
                    if (itm[$scope.valueField] == !undefined)
                      return item[$scope.valueField] == itm[$scope.valueField]
                    else
                      return item[$scope.textField] == itm[$scope.textField]
                  }).length == 0) {

                  if(itm.Nome != undefined && itm.Nome != "") {
                    itm.Selecionado = null;
                    $scope.tags.push(itm);
                  }
                }
                $scope.newValue = "";
                input.val('');
                input.blur();
                $('#txtBusca').autocomplete('close');
              }
              else {
                // if (itm != undefined) {
                //   $scope.tags = [];
                //   $scope.tags.push(itm);
                //   $scope.newValue = "";
                // }
              }

            }
            $('#txtBusca').autocomplete('close');
          }

          $scope.remove = function(idx, itm) {
            $scope.limiteAlcancado = false;
            $scope.tags.splice(idx, 1);
            input.attr('disabled', false);

            if(itm.Principal == true)
              $scope.selecionado = null;

            if ($scope.removed != undefined)
              return $scope.removed(itm);
          };

          input.bind('keypress', function (event) {
            if (event.keyCode == 13) {
              $scope.$apply(function () {
                $scope.add({Nome: $scope.newValue});
                $scope.newValue = "";
              });
            }
            $element.find('input').focus();
          });

          input.bind('focus', function(event) {
            $element.find('input').autocomplete("search");
          });
        }
      };
    });
})();

(function() {

  angular.module('app.directive')
    .directive('breadcrumb', ['$interpolate', '$state', 'appSettings', function($interpolate, $state, appSettings) {
      return {
        restrict: 'E',
        templateUrl: 'view/common/breadcrumb.html',
        scope: {
          displaynameProperty: '@',
          abstractProxyProperty: '@?'
        },
        link: function(scope) {
          scope.breadcrumbs = [];
          if ($state.$current.name !== '') {
            updateBreadcrumbsArray();
          }
          scope.$on('$stateChangeSuccess', function() {
            updateBreadcrumbsArray();
          });

          /**
           * Start with the current state and traverse up the path to build the
           * array of breadcrumbs that can be used in an ng-repeat in the template.
           */
          function updateBreadcrumbsArray() {
            var workingState;
            var displayName;
            var breadcrumbs = [];
            var currentState = $state.$current;

            var authData = appSettings.getUserStore();


            while (currentState && currentState.name !== '') {
              workingState = getWorkingState(currentState);
              if (workingState) {
                displayName = getDisplayName(workingState);

                if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                  breadcrumbs.push({
                    displayName: displayName,
                    route: workingState.name
                  });
                }
              }
              currentState = currentState.parent;
            }
            breadcrumbs.reverse();
            scope.breadcrumbs = breadcrumbs;
            if (breadcrumbs.length > 0)
              scope.title = breadcrumbs[breadcrumbs.length - 1].displayName
            else
              scope.title = "TITULO DA PÁGINA";

            if (authData) {
              scope.estabelecimento = authData.estabelecimento;
              scope.quantidade_estabelecimento = authData.quantidade_estabelecimento;
              scope.usuario = authData.apelido || authData.login;
            }

          }

          /**
           * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
           * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
           * set it to `false` which means this breadcrumb level will be skipped entirely.
           * @param currentState
           * @returns {*}
           */
          function getWorkingState(currentState) {
            var proxyStateName;
            var workingState = currentState;
            if (currentState.abstract === true) {
              if (typeof scope.abstractProxyProperty !== 'undefined') {
                proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
                if (proxyStateName) {
                  workingState = $state.get(proxyStateName);
                } else {
                  workingState = false;
                }
              } else {
                workingState = false;
              }
            }
            return workingState;
          }

          /**
           * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
           * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
           * properties on the state config object, by using the usual {{ }} syntax.
           * @param currentState
           * @returns {*}
           */
          function getDisplayName(currentState) {
            var interpolationContext;
            var propertyReference;
            var displayName;

            if (!scope.displaynameProperty) {
              // if the displayname-property attribute was not specified, default to the state's name
              return currentState.name;
            }
            propertyReference = getObjectValue(scope.displaynameProperty, currentState);

            if (propertyReference === false) {
              return false;
            } else if (typeof propertyReference === 'undefined') {
              return currentState.name;
            } else {
              // use the $interpolate service to handle any bindings in the propertyReference string.
              interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
              displayName = $interpolate(propertyReference)(interpolationContext);
              return displayName;
            }
          }

          /**
           * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
           * value found at that path.
           *
           * @param objectPath
           * @param context
           * @returns {*}
           */
          function getObjectValue(objectPath, context) {
            var i;
            var propertyArray = objectPath.split('.');
            var propertyReference = context;

            for (i = 0; i < propertyArray.length; i++) {
              if (angular.isDefined(propertyReference[propertyArray[i]])) {
                propertyReference = propertyReference[propertyArray[i]];
              } else {
                // if the specified property was not found, default to the state's name
                return undefined;
              }
            }
            return propertyReference;
          }

          /**
           * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
           * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
           * @param state
           * @param breadcrumbs
           * @returns {boolean}
           */
          function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
            var i;
            var alreadyUsed = false;
            for (i = 0; i < breadcrumbs.length; i++) {
              if (breadcrumbs[i].route === state.name) {
                alreadyUsed = true;
              }
            }
            return alreadyUsed;
          }
        }
      };
    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller', [
        	'ticket.controller.authentication',
          'ticket.controller.site',
          'ticket.controller.operacao',
          'ticket.controller.cliente'
    	]);
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');

// moment.js locale configuration
// locale : brazilian portuguese (pt-br)
// author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

    (function (factory) {
      if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
      } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
      } else {
        factory(window.moment); // Browser global
      }
    }(function (moment) {
      return moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
        weekdaysShort : 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin : 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
        longDateFormat : {
          LT : 'HH:mm',
          L : 'DD/MM/YYYY',
          LL : 'D [de] MMMM [de] YYYY',
          LLL : 'D [de] MMMM [de] YYYY [às] LT',
          LLLL : 'dddd, D [de] MMMM [de] YYYY [às] LT'
        },
        calendar : {
          sameDay: '[Hoje às] LT',
          nextDay: '[Amanhã às] LT',
          nextWeek: 'dddd [às] LT',
          lastDay: '[Ontem às] LT',
          lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
              '[Último] dddd [às] LT' : // Saturday + Sunday
              '[Última] dddd [às] LT'; // Monday - Friday
          },
          sameElse: 'L'
        },
        relativeTime : {
          future : 'em %s',
          past : '%s atrás',
          s : 'segundos',
          m : 'um minuto',
          mm : '%d minutos',
          h : 'uma hora',
          hh : '%d horas',
          d : 'um dia',
          dd : '%d dias',
          M : 'um mês',
          MM : '%d meses',
          y : 'um ano',
          yy : '%d anos'
        },
        ordinal : '%dº'
      });
    }));

    //angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 1000);

    /* Brazilian initialisation for the jQuery UI date picker plugin. */
    /* Written by Leonildo Costa Silva (leocsilva@gmail.com). */
    jQuery(function($){
      $.datepicker.regional['pt-BR'] = {
        closeText: 'Fechar',
        prevText: '&#x3c;Anterior',
        nextText: 'Pr&oacute;ximo&#x3e;',
        currentText: 'Hoje',
        monthNames: ['Janeiro','Fevereiro','Mar&ccedil;o','Abril','Maio','Junho',
          'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun',
          'Jul','Ago','Set','Out','Nov','Dez'],
        dayNames: ['Domingo','Segunda-feira','Ter&ccedil;a-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sabado'],
        dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''};
      $.datepicker.setDefaults($.datepicker.regional['pt-BR']);
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, menuProvider) {

    $stateProvider
      .state('404', {
        url: '/404',
        views: {
          'root': {
            templateUrl: 'view/common/404.tmpl.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        }
      })

    .state('401', {
      url: '/401',
      views: {
        'root': {
          templateUrl: 'view/common/401.tmpl.html',
          controller: 'ErrorPageController',
          controllerAs: 'vm'
        }
      }
    })

    .state('500', {
      url: '/500',
      views: {
        'root': {
          templateUrl: 'view/common/500.tmpl.html',
          controller: 'ErrorPageController',
          controllerAs: 'vm'
        }
      }
    });


    // set default routes when no path specified
    $urlRouterProvider.when('', '/login');
    $urlRouterProvider.when('/', '/login');

    // always goto 404 if route not found
    $urlRouterProvider.otherwise('/404');



  }

})();
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });



(function () {
  angular.module("ticket")
    .factory("common", ["$rootScope", "$state", "$stateParams", "$q", "$http", "appSettings", "$log", "$timeout", "toaster", "$uibModal", "ticket.service.controleacesso.login", function ($rootScope, $state, $stateParams, $q, $http, appSettings, $log, $timeout, toaster, $uibModal, loginSvc) {

      var AlertType = {
        INFO: 'info',
        ERRO: 'error',
        ALERTA: 'warning',
        SUCESSO: 'success',
        AGUARDE: 'wait'
      };
      var utils = {
        AlertType: AlertType,
        Messages: {
          post: {
            tit: 'Alteração de informações',
            msg: 'Atualização realizada com sucesso!',
            type: AlertType.SUCESSO
          },
          put: {
            tit: 'Inclusão de informações',
            msg: 'Cadastro realizado com sucesso!',
            type: AlertType.SUCESSO
          },
          status: {
            tit: 'Alteração de status',
            msg: 'Atualização de status realizado com sucesso!',
            type: AlertType.SUCESSO
          },
          del: {
            tit: "Exclusão de informações",
            msg: "Exclusão realizada com sucesso!",
            type: AlertType.SUCESSO
          },
          putPhoto: {
            tit: "Envio de foto",
            msg: "A foto foi enviada com sucesso!",
            type: AlertType.SUCESSO
          },
          errorQuery: {
            tit: "Resultado da Pesquisa:",
            msg: "Nenhum registro encontrado!",
            type: AlertType.INFO
          }
        },
        Confirm: function (tit, msg) {
          return $uibModal.open({
            animation: false,
            templateUrl: "view/common/confirm.html",
            controller: function ($uibModalInstance, itm) {
              var vm = this;
              vm.itm = itm;
              vm.no = function () {
                $uibModalInstance.dismiss('cancel');
              }
              vm.yes = function () {
                $uibModalInstance.close(vm.item);
              }
            },
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
              itm: function () {
                return {
                  tit: tit,
                  msg: msg
                };
              }
            }
          })
            .result;
        },
        SendAlert: function (data) {
          toaster.pop(data.type, data.tit, data.msg);
        },
        ShowError: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.ERRO
          });
        },
        ShowInfo: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.INFO
          });
        },
        ShowWarning: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.ALERTA
          });
        },
        ShowSuccess: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.SUCESSO
          });
        },
        Estados: [
              {"nome": "Acre", "sigla": "AC"},
              {"nome": "Alagoas", "sigla": "AL"},
              {"nome": "Amapá", "sigla": "AP"},
              {"nome": "Amazonas", "sigla": "AM"},
              {"nome": "Bahia", "sigla": "BA"},
              {"nome": "Ceará", "sigla": "CE"},
              {"nome": "Distrito Federal", "sigla": "DF"},
              {"nome": "Espírito Santo", "sigla": "ES"},
              {"nome": "Goiás", "sigla": "GO"},
              {"nome": "Maranhão", "sigla": "MA"},
              {"nome": "Mato Grosso", "sigla": "MT"},
              {"nome": "Mato Grosso do Sul", "sigla": "MS"},
              {"nome": "Minas Gerais", "sigla": "MG"},
              {"nome": "Pará", "sigla": "PA"},
              {"nome": "Paraíba", "sigla": "PB"},
              {"nome": "Paraná", "sigla": "PR"},
              {"nome": "Pernambuco", "sigla": "PE"},
              {"nome": "Piauí", "sigla": "PI"},
              {"nome": "Rio de Janeiro", "sigla": "RJ"},
              {"nome": "Rio Grande do Norte", "sigla": "RN"},
              {"nome": "Rio Grande do Sul", "sigla": "RS"},
              {"nome": "Rondônia", "sigla": "RO"},
              {"nome": "Roraima", "sigla": "RR"},
              {"nome": "Santa Catarina", "sigla": "SC"},
              {"nome": "São Paulo", "sigla": "SP"},
              {"nome": "Sergipe", "sigla": "SE"},
              {"nome": "Tocantins", "sigla": "TO"}
            ]

      };

      var common = {
        controller: {
          basic: function (obj) {
            var vm = {};
            vm.utils = utils;

            obj.__proto__ = vm;

            return obj;
          },
          master: function (obj, svc, $scope) {
            var vm = {};
            vm.utils = utils;


            var _queried = $rootScope.$on('queried', function (evt, items) {
              vm.items = items;
            });

            $scope.$on('$destroy', _queried);

            var _canceled = $rootScope.$on('canceled', function () {
              if (vm.items && vm.items.length > 0) {
                for (var i = 0; i < vm.items.length; i++)
                  vm.items[i].updated = false;

                $state.go('^.grid', {
                  items: vm.items
                });
              } else {
                $state.go('^.grid');
              }

            });

            $scope.$on('$destroy', _canceled);

            var _saved = $rootScope.$on('saved', function (evt, pk) {

              if (vm.items && vm.items.length > 0) {
                //VERIFICA SE A PK QUE RETORNOU DA EDIÇÃO EXISTE NA GRID
                var rows = vm.items.filter(function (itm) {
                  itm.updated = false;
                  for (var i in pk) {
                    if (itm[i] != pk[i])
                      return false;
                  }

                  return true;
                });

                //BUSCA O REGISTRO DA GRID ATUALIZADO NO SERVIDOR
                svc.getOne(pk)
                  .then(function (res) {

                    //POSICIONA O REGISTRO ATUALIZADO NA GRID. SE FOR INCLUSÃO, IRÁ PARA A PRIMEIRA POSIÇÃO

                    var index = (rows.length > 0) ? vm.items.indexOf(rows[0]) : -1;

                    res[0].updated = true;

                    if (index == -1) {
                      vm.items.splice(0, 0, res[0]);
                    } else {
                      vm.items.splice(index, 1, res[0]);
                    }

                    $state.go('^.grid', {
                      items: vm.items
                    });

                  });
              } else {
                svc.getOne(pk)
                  .then(function (res) {
                    $state.go('^.grid', {
                      items: res
                    });
                  });
              }


            });

            $scope.$on('$destroy', _saved);

            obj.__proto__ = vm;

            return obj;

          },
          grid: function (obj, svc) {
            var vm = {};
            vm.utils = utils;
            vm.Filter = {};
            vm.debounce = 0;
            vm.searching = false;
            vm.complete = false;
            vm.items = [];
            var pageSize = 20;
            vm.isPost = true;

            //PESQUISA DA GRID
            vm.search = function (inScroll) {

              if (vm.searching) return;

              vm.searching = true;

              if (!inScroll || vm.isPost) {
                vm.isPost = false;
                vm.page = 0;
                vm.complete = false;
                vm.items = [];
              }
              svc.getAll({
                Config: {
                  Skip: vm.page,
                  Top: pageSize
                },
                Filter: vm.Filter
              })
                .then(function (v) {
                  $rootScope.$emit('queried', v);

                  vm.items = vm.items.concat(v);

                  if (v.length < pageSize)
                    vm.complete = true;

                  if (v.length > 0) {
                    vm.page += 1;
                  }


                  if (obj.loaded)
                    obj.loaded();
                })
                .finally(function () {
                  vm.searching = false;
                });
            }


            //INCLUSÃO
            vm.add = function () {
              $state.go('^.form');
            }

            //EDIÇÃO
            vm.edit = function (pk) {

              $state.go('^.form', pk);
            }

            //STATUS ON/OFF
            vm.toggle = function (itm) {
              svc.toggle(itm).then(function (v) {
                itm.Status = v;
              });
            }

            //EXCLUSÃO
            vm.del = function (itm) {
              utils.Confirm("Exclusão de registro", "Deseja excluir esse registro?").then(function () {
                svc.del(itm).then(function (v) {
                  vm.items.splice(vm.items.indexOf(itm), 1);
                  utils.ShowSuccess("Exclusão de registro.", "Esse registro foi excluído com sucesso!");
                });
              });
            }


            if ($stateParams.items) {
              vm.items = angular.fromJson(angular.toJson($stateParams.items));
            }

            if ($stateParams.filter) {
              vm.Filter = angular.fromJson($stateParams.filter);
              vm.search();
            }


            obj.__proto__ = vm;

            return obj;

          },
          form: function (obj, svc) {
            var vm = {
              utils: utils
            };


            pk = angular.fromJson($stateParams);

            var hasProp = false;
            if (pk != null) {
              for (var _p in pk) {
                if (pk[_p] != "" && pk[_p] != null) {
                  hasProp = true;
                  break;
                }
              }
            }

            if (!hasProp) {
              vm.action = "INCLUSÃO";
              vm.item = {};
            } else {
              vm.action = "EDIÇÃO";
              vm.loading = true;
              svc.get(pk)
                .then(function (res) {
                  vm.item = res;
                  if (obj.loaded)
                    obj.loaded();
                }, function (err) {
                  vm.cancel();
                })
                .finally(function () {
                  vm.loading = false;
                });
            }


            vm.cancel = function () {
              $rootScope.$emit('canceled');
              $state.go('^.grid')
            };

            vm.save = function () {
              vm.loading = true;
              if (!hasProp) {
                svc.post(vm.item)
                  .then(function (v) {
                    utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', v);
                    $state.go('^.grid');
                  })
                  .finally(function () {
                    vm.loading = false;
                  });
              } else {
                svc.put(vm.item)
                  .then(function (v) {
                    utils.ShowSuccess("Atualização de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', pk);
                    $state.go('^.grid');
                  })
                  .finally(function () {
                    vm.loading = false;
                  });
              }
            }

            obj.__proto__ = vm;

            return obj;
          },
          instantiate: function (obj) {
            var res = {
              utils: utils
            };

            obj.__proto__ = res;

            return obj;
          }
        },
        service: {

          basic: function (obj, url) {
            var logLevel = {
              ERROR: 1,
              WARNING: 2,
              DEBUG: 4,
              INFO: 8,
              LOG: 16
            };

            function log(msg, level) {
              if (level == logLevel.ERROR && (appSettings.debugLevel & logLevel.ERROR > 0)) {
                $log.error(msg);
              }
              if (level == logLevel.WARNING && (appSettings.debugLevel & logLevel.WARNING > 0)) {
                $log.warn(msg);
              }
              if (level == logLevel.DEBUG && (appSettings.debugLevel & logLevel.DEBUG > 0)) {
                $log.debug(msg);
              }
              if (level == logLevel.INFO && (appSettings.debugLevel & logLevel.INFO > 0)) {
                $log.info(msg);
              }
              if (level == logLevel.LOG && (appSettings.debugLevel & logLevel.LOG > 0)) {
                $log.log(msg);
              }
            }


            function result_success(result) {
              return result.data;
            }

            function req(service, data, config) {

              function fail(err) {

                var msg = "";

                switch (err.status) {
                  case -1:
                    msg = "Falha ao acessar o servidor. Verifique sua internet.";
                    break;
                  case 401:
                    msg = "Serviço não autorizado. Verifique se você tem permissão para acessar esse recurso.";
                    break;
                  case 404:
                    msg = "Serviço não localizado. Talvez ele esteja apenas indisponível.";
                    break;
                  default:
                    msg = "Falha na chamada do serviço.";
                    break;
                }

                if (err.status != 401) {

                  msg = (err.data && err.data.Message) ? err.data.Message : msg;
                  msg = (err.data && err.data.error_description) ? err.data.error_description : msg;
                  msg = (err.data && err.data.ExceptionMessage) ? err.data.ExceptionMessage : msg;

                  log(err.config.method + ": " + err.config.url, logLevel.INFO);
                  if( err.data && err.data.ExceptionType == 'Barn.Util.BarnWarning' )
                    utils.ShowWarning("Alerta sobre a operação", msg);
                  else
                    utils.ShowError("Erro no servidor", msg);

                  return $q.reject(err);
                } else {
                  var usr = appSettings.getUserStore();
                  if (usr) {
                    return loginSvc.RefreshToken(usr.id_estabelecimento).then(function (v) {
                        return req(service, data, config);
                      },
                      function (err) {
                        return $uibModal.open({
                          backdrop: 'static',
                          keyboard: false,
                          animation: true,
                          //templateUrl: 'view/ingresso/ingresso/template/regra.tmpl.html',
                          template: '' +
                          '<div class="middle-box text-center loginscreen  animated fadeInDown"><div>' +
                          '<p>Identifique-se para continuar.</p>' +
                          '<form class="m-t" role="form" novalidate name="frm">' +
                          '<ng-field label="Email" name="email" ng-disabled="true" model="vm.user.email" type="text" required="true"></ng-field>' +
                          '<ng-field label="Senha" name="pwd" model="vm.user.password" type="password" required="true"></ng-field>' +
                          '<button type="submit" class="btn btn-primary block full-width m-b" ng-click="vm.loginClick()"  ng-disabled="vm.loading || frm.$invalid">' +
                          '<i class="fa " ng-disabled="vm.loading" ng-class="{\'fa-sing-in\': !vm.loading,  \'fa-spinner fa-pulse\': vm.loading}" ></i> Login' +
                          '</button>' +
                          '</form>' +
                          '</div>' +
                          '</div>',
                          controller: function ($uibModalInstance) {
                            var vm = this;
                            loginSvc.Logout(true);

                            vm.user = {
                              email: usr.login
                            }

                            vm.loginClick = function () {
                              vm.loading = true;
                              loginSvc.Logon(vm.user).then(function (v) {
                                  $uibModalInstance.close();
                                  //(v.estabelecimento == null ) ?  $state.go('auth.establishment') : $state.go('site.home');
                                },
                                function (e) {
                                  var msg = "Usuário/Senha incorretos. Verifique as informações e tente novamente.";
                                  if (e.status == -1) {
                                    msg = "Falha ao acessar o serviço. Verifique sua conexão com a internet."
                                  } else if (e.data && e.data.error == "no_establishment") {
                                    msg = e.data.error_description;
                                  }

                                  toaster.pop("error", "Identificação no sistema", msg);

                                })
                                .finally(function (e) {
                                  vm.loading = false;
                                });

                            }
                          },
                          controllerAs: 'vm',
                          size: 'sm',
                          resolve: {}
                        }).result.then(function () {
                          return req(service, data, config)
                        });
                      })


                  }
                }

              }

              config = config || {};
              config.supressError = config.supressError || false;

              if(!config.headers){
                config.headers = {};
              }
              config.headers.timestamp = moment( new Date()).format();

              if (config.supressError) {
                return $http.post(appSettings.url + url + service, data, config).then(result_success);
              } else {
                return $http.post(appSettings.url + url + service, data, config).then(result_success, fail);
              }
            }


            var res = {
              utils: utils,
              request: req,
              log: log
            }


            obj.__proto__ = res;

            return obj;

          },
          instantiate: function (obj, url) {

            obj = obj || {};

            obj.cachedData = [];

            function listCached(filter) {
              return $q(function (resolve, reject) {
                $timeout(function () {
                  resolve(
                    (
                      (obj.cachedData.length == 0) ?
                        obj.list({}).then(function (r) {
                          obj.cachedData = r;
                          return ((filter) ? obj.cachedData.filter(filter) : obj.cachedData);
                        }) :
                        ((filter) ? obj.cachedData.filter(filter) : obj.cachedData)
                    )
                  );

                }, 0, true)
              });

            }


            var res = {

              get: function (pk) {
                return this.request("get", pk)
              },
              getOne: function (pk) {
                return this.request("getone", pk);
              },
              getAll: function (filter) {
                return this.request("getall", filter);
              },
              put: function (mdl) {
                return this.request("put", mdl);
              },
              post: function (mdl) {
                return this.request("post", mdl);
              },
              del: function (pk) {
                return this.request("del", pk);
              },
              toggle: function (mdl) {
                return this.request("toggle", mdl);
              },
              list: function (filter) {
                return this.request("list", filter);
              },
              listCached: listCached
            }


            obj.__proto__ = common.service.basic(res, url);


            return obj;
          }
        }
      };

      return common;


    }]);
})();

(function(){
	angular.module("app",[
        'app.directive'
    ]);
})();
(function () {
  "use strict";

  var storeAuthName = "oAuthTICKET_1.0"; //MUDANDO ESSA VERSÃO, TODAS AS CONEXÕES EM CACHE NO CLIENTE SERÃO REINICIADAS

  angular
    .module("app")
    .provider("appSettings", [
      function () {
        var languages = [];
        var settings = {
          url: "https://api.prd3.divertix.com.br/api/",
          appId: "TICKET.PRODUTOR",
          appKey: "16065D42-7DC4-4F5F-A140-A2D3B4F00A15",
          auth: "https://api.prd3.divertix.com.br/token",
          ga: "UA-97864533-4" /*'UA-97864533-3*/,
          versao: "1.1.3",
          pageSize: 30,
          debugLevel: 15, //DEBUG LEVEL: 1. ERRO, 2. WARNING, 4. DEBUG, 8. INFO
          expire: 5, //5 minutos
          idPerfilCliente: "094fff4a-8c8c-418f-8b14-791885dd647f",
        };

        this.addLanguage = addLanguage;
        this.getUserStore = getUserStore;
        this.setUserStore = setUserStore;
        this.clearUserStore = clearUserStore;

        var _lastRequest = null;

        function getLastRequest() {
          return _lastRequest;
        }

        function updateLastRequest() {
          _lastRequest = new Date();
        }

        function getUserStore() {
          var $window = angular.injector(["ng"]).get("$window");
          var u = $window.sessionStorage.getItem(storeAuthName);
          return u != "" && u != null ? angular.fromJson(u) : null;
        }

        function setUserStore(v) {
          var $window = angular.injector(["ng"]).get("$window");
          return $window.sessionStorage.setItem(
            storeAuthName,
            angular.toJson(v)
          );
        }

        function clearUserStore() {
          var $window = angular.injector(["ng"]).get("$window");
          $window.sessionStorage.removeItem(storeAuthName);
        }

        function addLanguage(newLanguage) {
          languages.push(newLanguage);
        }

        // Service
        this.$get = function () {
          return {
            url: settings.url,
            appId: settings.appId,
            appKey: settings.appKey,
            auth: settings.auth,
            pageSize: settings.pageSize,
            debugLevel: settings.debugLevel,
            languages: languages,
            getUserStore: getUserStore,
            setUserStore: setUserStore,
            clearUserStore: clearUserStore,
            getLastRequest: getLastRequest,
            updateLastRequest: updateLastRequest,
            expire: settings.expire,
            ga: settings.ga,
            versao: settings.versao,
            idPerfilCliente: settings.idPerfilCliente,
          };
        };
      },
    ])

    .provider("rolesProvider", [
      "appSettingsProvider",
      function (appSettings) {
        this.$get = [
          "$http",
          function ($http) {
            return {
              IsInRole: function (IdTela) {
                return $http
                  .post(
                    appSettings.$get().url + "controleacesso/perfil/isinrole",
                    { IdFuncionalidade: IdTela }
                  )
                  .then(function (v) {
                    //console.log(v.data);
                    return v.data;
                  });
              },
            };
          },
        ];
      },
    ])

    .constant("GuidEmpty", "00000000-0000-0000-0000-000000000000")
    .provider("menu", [
      function () {
        var menuLeft = [];
        this.left = {
          add: function (itm) {
            menuLeft.push(itm);
          },
        };
        this.$get = function () {
          return {
            menuLeft: menuLeft,
          };
        };
      },
    ])
    .factory("BearerAuthInterceptor", [
      "$q",
      "$rootScope",
      "appSettings",
      function ($q, $rootScope, appSettings) {
        var authData = appSettings.getUserStore();

        var $logon = $rootScope.$on("app.logon", function (arg, v) {
          authData = v;
        });
        var $logoff = $rootScope.$on("app.logoff", function (arg, v) {
          authData = null;
        });

        return {
          request: function (config) {
            config.headers = config.headers || {};

            if (authData && authData.access_token)
              config.headers.Authorization = "Bearer " + authData.access_token;

            appSettings.updateLastRequest();

            return $q.when(config);
          },
        };
      },
    ])

    .config([
      "$httpProvider",
      "$provide",
      function ($httpProvider, $provide) {
        $httpProvider.interceptors.push("BearerAuthInterceptor"); //OAuth 2.0
        //$httpProvider.interceptors.push('dateInterceptor');

        $provide.decorator("uibDatepickerPopupDirective", function ($delegate) {
          var directive = $delegate[0];
          var link = directive.link;

          directive.compile = function () {
            return function (scope, element, attrs) {
              link.apply(this, arguments);
              element.mask("99/99/9999");
            };
          };
          return $delegate;
        });
      },
    ])
    .directive("menuLeft", [
      "$timeout",
      "menu",
      function ($timeout, menu) {
        return {
          restrict: "E",
          templateUrl: "view/common/navigation.html",
          controller: [
            "$scope",
            "$state",
            "$rootScope",
            "$location",
            "appSettings",
            "ticketSettings",
            function (
              $scope,
              $state,
              $rootScope,
              $location,
              appSettings,
              ticketSettings
            ) {
              var vm = this;

              $rootScope.$state = $state;

              var authData = appSettings.getUserStore();

              vm.Nome = authData.apelido || authData.login;
              vm.Perfil = authData.perfil;
              vm.items = menu.menuLeft;
              vm.appSettings = ticketSettings;
            },
          ],
          controllerAs: "vm",
        };
      },
    ])
    .filter("trustUrl", [
      "$sce",
      function ($sce) {
        return function (recordingUrl) {
          return $sce.trustAsResourceUrl(recordingUrl);
        };
      },
    ])
    .run([
      "appSettings",
      "$rootScope",
      "$window",
      "$location",
      "$stateParams",
      "$q",
      function (appSettings, $rootScope, $window, $location, $stateParams, $q) {
        //$window.ga('create', appSettings.ga, 'auto');

        $rootScope.$on(
          "$stateChangeStart",
          function (event, toState, toStateParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;
          }
        );

        $rootScope.$on("$stateChangeSuccess", function (event) {
          //$window.ga('send', 'pageview', $location.path());
        });
      },
    ]);

  function disableMenu(menuName, stateParentName, items) {
    var childs = getStateChilds(stateParentName, items);

    for (var i = 0; i < childs.length; i++) {
      if (childs[i].name === menuName) childs[i].disabled = true;
    }

    return true;
  }

  function enableMenu(menuName, stateParentName, items) {
    var childs = getStateChilds(stateParentName, items);

    for (var i = 0; i < childs.length; i++) {
      if (childs[i].name === menuName) childs[i].disabled = false;
    }

    return true;
  }

  function getStateChilds(stateName, items) {
    var childs = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].name === stateName) {
        childs = items[i].childs;
      }
    }
    return childs;
  }
})();

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("view/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>{{main.helloText}}</h1><small>{{main.descriptionText}} sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br>sadflk jaslkdjf laksdjf lkasdjflaksjdflkasjdf lkajlkaj<br><i class=\"glyphicon glyphicon-pencil\"></i></small></div></div></div></div>");
$templateCache.put("view/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("view/controller/site/home/home.tmpl.html","<div layout=\"row\" flex=\"\" layout-padding=\"\" layout-fill=\"\" layout-align=\"center center\"><div flex=\"40\" flex-lg=\"50\" flex-md=\"70\" flex-xs=\"100\"><md-card><md-toolbar class=\"padding-20\"><div flex=\"\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{::vm.triSettings.logo}}\" alt=\"{{vm.triSettings.name}}\"></div><div layout=\"row\" layout-align=\"center center\"><h1 class=\"md-headline\" translate=\"\">Home</h1></div></md-toolbar><md-content class=\"md-padding\">pagina inicial</md-content></md-card></div></div>");
$templateCache.put("view/controller/site/layouts/index.tmpl.html","<div class=\"full-image-background mb-bg-fb-05\" layout=\"row\" layout-fill=\"\"><div class=\"animate-wrapper\" flex=\"\" layout=\"row\"><div id=\"ui-login\" class=\"login-frame\" ui-view=\"\" flex=\"\" layout=\"column\"></div></div></div>");
$templateCache.put("view/authentication/_content.html","<div id=\"wrapper\" class=\"top-navigation\"><div id=\"page-wrapper\" class=\"fundo-content-secundario {{$state.current.name}}\"><div class=\"wrapper wrapper-content\"><div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div></div></div></div>");
$templateCache.put("view/authentication/index.html","<div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div>");
$templateCache.put("view/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("view/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">Versão <strong>1.0</strong></div><div><strong>Copyright</strong> Divertix &copy; 2018</div></div>");
$templateCache.put("view/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("view/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"></div><div class=\"logo-element\">&nbsp;</div></li><li ng-repeat=\"itm in vm.items\" ng-class=\"{divider: itm.type == \'divider\', active: $state.includes(itm.state)}\"><a ng-if=\"itm.type != \'divider\'\" href=\"index.html\"><i class=\"{{itm.icon}}\"></i> <span class=\"nav-label\">{{itm.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"itm.childs\" class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(itm.state)}\"><li ng-repeat=\"itm2 in itm.childs\" ng-if=\"!itm2.disabled\" ui-sref-active=\"active\"><a ui-sref=\"{{itm2.state}}\">{{ itm2.name }}</a></li></ul></li></ul></div></nav>");
$templateCache.put("view/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right m-r-sm\" style=\"float:right\"><li><a href=\"#\"><i class=\"fa fa-sign-out\"></i> Sair</a></li></ul></nav></div>");
$templateCache.put("view/site/_content.html","<div id=\"wrapper\"><menu-left></menu-left><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'view/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div></div></div>");
$templateCache.put("view/authentication/establishment/index.html","<div class=\"ibox float-e-margins animated fadeInDown\"><div class=\"ibox-title\"><h5>Selecione o seu estabelecimento</h5><div class=\"ibox-tools\"><span class=\"label label-info-light pull-right\">{{vm.estabelecimentos.length}} Estabelecimentos</span></div></div><div class=\"ibox-content\"><div><div class=\"list-group\"><a class=\"list-group-item\" ng-repeat=\"item in vm.estabelecimentos\" ng-click=\"vm.selecionar(item)\" ng-if=\"!vm.loading\"><h4 class=\"list-group-item-heading\">{{item.NomeEstabelecimento}}</h4><p class=\"list-group-item-text\">{{item.NomeEmpresa}}</p></a> <span class=\"list-group-item\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i> <span class=\"sr-only\">Carregando...</span></span></div></div></div></div>");
$templateCache.put("view/authentication/forgot/forgot.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">Esqueci minha senha</h2><p>Digite o código que aparece na imagem e entre com o seu e-mail</p><form class=\"m-t\" role=\"form\" name=\"frm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"widget-head-color-box navy-bg p-lg text-center\"><div ng-if=\"!vm.ImgCaptcha\"><i class=\"fa fa-4x\" ng-class=\"{\'fa-spinner fa-pulse\':!vm.loadingError, \'fa-chain-broken\': vm.loadingError}\"></i></div><img ng-src=\"{{vm.ImgCaptcha}}\" class=\"img-responsive\" ng-if=\"vm.ImgCaptcha\"></div><div class=\"widget-text-box\"><a class=\"btn btn-sm btn-white btn-block\" ng-click=\"vm.renderCaptcha()\" ng-disabled=\"vm.loadingCaptcha\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': vm.loadingCaptcha}\"></i> Não consigo ler a imagem</a></div></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Código\" name=\"codigo\" model=\"vm.user.Captcha\" type=\"text\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Email\" name=\"email\" model=\"vm.user.Email\" type=\"email\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.resetClick()\" ng-disabled=\"vm.reseting || !frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\':!vm.reseting, \'fa-spinner fa-pulse\': vm.reseting}\"></i> Enviar minha senha</button></div></div></form></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div>");
$templateCache.put("view/authentication/forgot/reset.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">{{vm.pageTitle}}</h2><p ng-if=\"vm.showFields\">Informe sua nova senha e redigite-a para confirmar a alteração.</p><form class=\"m-t\" role=\"form\" name=\"frm\" ng-if=\"vm.showFields\"><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Senha\" name=\"senha\" model=\"vm.user.Password\" type=\"password\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Confirme sua senha\" name=\"confirma\" model=\"vm.user.Confirma\" type=\"password\" required=\"true\" validate-async=\"vm.ComparaSenha\" validate-async-error=\"Os campos são diferentes\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.Change()\" ng-disabled=\"vm.loading || !frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\':!vm.loading, \'fa-spinner fa-pulse\': vm.loading}\"></i> Confirmar</button></div></div></form></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div>");
$templateCache.put("view/authentication/login/login.html","<div class=\"login-bg\"></div><div class=\"content\"><div class=\"login-middle-box text-center loginscreen animated fadeInDown\"><div><div></div><h3><span translate=\"\">Bem vindo a</span> DIVERTIX</h3><p>Identifique-se para continuar.</p><form class=\"m-t\" role=\"form\" novalidate=\"\" name=\"frm\"><ng-field label=\"Email\" ng-enter=\"vm.loginClick()\" name=\"email\" model=\"vm.user.email\" type=\"email\" required=\"true\"></ng-field><ng-field label=\"Senha\" ng-enter=\"vm.loginClick()\" name=\"pwd\" model=\"vm.user.password\" type=\"password\" required=\"true\"></ng-field><button type=\"button\" class=\"btn btn-success block full-width m-b\" ng-click=\"vm.loginClick()\" ng-disabled=\"vm.loading || frm.$invalid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\': !vm.loading, \'fa-spinner fa-pulse\': vm.loading}\" ng-disabled=\"vm.loading\"></i> Login</button><p class=\"text-muted text-center\"><small>Não possui uma conta?</small></p><a class=\"btn btn-sm btn-white btn-block\" ng-click=\"vm.onClickSignUp()\"><i class=\"fa fa-edit\"></i> Cadastre-se</a></form></div></div></div>");
$templateCache.put("view/authentication/profile/profile.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Profile</div>{{vm.user }}<div class=\"panel-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Apelido\" model=\"vm.item.Apelido\" type=\"text\" maxlength=\"40\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Login\" label=\"Email\" model=\"vm.item.Login\" type=\"email\" maxlength=\"120\" required=\"\" ng-disabled=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"DataNascimento\" label=\"Data Nascimento\" model=\"vm.item.DataNascimento\" type=\"date\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"Telefone\" label=\"Telefone\" model=\"vm.item.Telefone\" type=\"text\" mask=\"(99)99999-999?9\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Ramal\" label=\"Ramal\" model=\"vm.item.Ramal\" type=\"text\" mask=\"?9?9?9?9?9?9\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Perfil\" label=\"Perfil\" model=\"vm.item.Perfil\" type=\"text\" ng-disabled=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\">Salvar</button></div></div>");
$templateCache.put("view/authentication/signup/signup.html","<div class=\"login-bg\"></div><div class=\"content\"><div class=\"signup-middle-box text-center signupscreen animated fadeInDown\"><div ng-if=\"!vm.ok\"><div></div><h3><span translate=\"\">Bem vindo a</span> DIVERTIX</h3><p>Crie sua conta.</p><form name=\"frm\" class=\"m-t\" role=\"form\"><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Email\" ng-enter=\"vm.loginClick()\" name=\"email\" model=\"vm.user.Login\" type=\"email\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Nome\" ng-enter=\"vm.loginClick()\" name=\"nome\" model=\"vm.user.Apelido\" type=\"text\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Data Nascimento\" ng-enter=\"vm.loginClick()\" name=\"datanascimento\" model=\"vm.user.DataNascimento\" type=\"date\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Telefone\" ng-enter=\"vm.loginClick()\" name=\"telefone\" model=\"vm.user.Telefone\" type=\"phone\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Ramal\" ng-enter=\"vm.loginClick()\" name=\"ramal\" model=\"vm.user.Ramal\" type=\"text\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Senha\" ng-enter=\"vm.loginClick()\" name=\"senha\" model=\"vm.user.senha\" type=\"password\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Confrmar Senha\" ng-enter=\"vm.loginClick()\" name=\"confirmarsenha\" model=\"vm.user.confirmarsenha\" type=\"password\" required=\"true\"></ng-field></div></div><button type=\"button\" ng-click=\"vm.save();\" class=\"btn btn-success block full-width m-b\" ng-disabled=\"!frm.$valid || vm.loading\">Registrar <i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.loading}\"></i></button></form></div><div ng-if=\"vm.ok\"><div class=\"linha\"><div class=\"coluna\"><div class=\"alinhar-txt-c m-top-32 m-baix-32\"><i class=\"fa fa-check-circle-o fa-4x\" aria-hidden=\"true\"></i><h2>Cadastro realizado com sucesso!</h2></div><div class=\"linha\"><div class=\"coluna-m-66 alinhar-c\"><div class=\"notificacao alerta m-top-32 m-baixo-32\"><h4 style=\"line-height: 40px\"><p style=\"margin:0;margin-bottom:10px;font-size:14px;\"><b>Em breve enviaremos um email com o status da sua solicitação.</b></p></h4></div></div></div></div></div></div></div></div>");
$templateCache.put("view/authentication/signup/validar.html","<div class=\"login-bg\"></div><div class=\"content\"><div class=\"signup-middle-box text-center signupscreen animated fadeInDown\"><div class=\"linha\"><div class=\"coluna\"><div class=\"alinhar-txt-c m-top-32 m-baix-32\"><i class=\"fa fa-envelope fa-4x\" aria-hidden=\"true\"></i><h2>Validação de e-mail</h2></div><div class=\"linha\"><div class=\"coluna-m-66 alinhar-c\"><div class=\"notificacao alerta m-top-32 m-baixo-32\"><h4 style=\"line-height: 40px\"><i class=\"fa fa-check-circle-o\" ng-if=\"vm.validado\"></i> {{vm.mensagem }}</h4></div></div></div></div></div></div></div>");
$templateCache.put("view/cliente/producao/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-5\"><ng-field name=\"Nome\" label=\"Nome Produção\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-xs-12 col-md-5\"><ng-field name=\"CNPJ\" label=\"CNPJ\" model=\"vm.item.CNPJ\" type=\"cnpj\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"Estado\" required=\"true\" type=\"select\" model=\"vm.item.UF\" options=\"vm.estadosList\" value-field=\"sigla\" text-field=\"nome\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Cidade\" ng-disabled=\"!vm.item.UF\" required=\"true\" type=\"select\" model=\"vm.item.IdCidade\" options=\"vm.cidadeList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Bairro\" label=\"Bairro\" model=\"vm.item.Bairro\" type=\"text\" maxlength=\"100\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Cep\" name=\"Cep\" type=\"cep\" model=\"vm.item.CEP\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field name=\"Logradouro\" label=\"Logradouro\" model=\"vm.item.Logradouro\" type=\"text\" maxlength=\"200\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Numero\" label=\"Numero\" model=\"vm.item.Numero\" type=\"number\" maxlength=\"50\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Complemento\" name=\"Complemento\" type=\"text\" model=\"vm.item.Complemento\" maxlength=\"60\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"DDD\" name=\"DDD\" type=\"number\" model=\"vm.item.DDD\" maxlength=\"2\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Telefone\" name=\"Telefone\" type=\"phone\" model=\"vm.item.Telefone\" maxlength=\"10\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Ramal\" name=\"Ramal\" type=\"number\" model=\"vm.item.Ramal\" maxlength=\"6\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-success pull-right\" ng-disabled=\"!frm.$valid\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/cliente/producao/grid.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" ng-hide=\"vm.items.length == 1\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR PRODUÇÃO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" ng-hide=\"vm.items.length == 1\"><div class=\"row\"><div class=\"col-md-9\"><div class=\"input-group m-b-xs\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"col-md-3\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button></div></div></div><br><div class=\"ibox-content\" ng-if=\"vm.items && vm.items.length > 0\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>CNPJ</th><th>Logradouro</th><th>Numero</th><th>Cidade</th><th>UF</th><th>Status</th><th>Editar</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.CNPJ}}</span></td><td class=\"project-title\"><span>{{item.Logradouro}}</span></td><td class=\"project-title\"><span>{{item.Numero}}</span></td><td class=\"project-title\"><span>{{item.Cidade}}</span></td><td class=\"project-title\"><span>{{item.UF}}</span></td><td class=\"center\">{{item.Status == 1 ? \'Ativo\' : \'Inativo\'}}</td><td class=\"center\"><div class=\"center\"><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i></a></div></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/cliente/producao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/site/home/detalhe.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ vm.estrutura.DataHoraInicio | date: \'dd/MM/yyyy HH:mm\' }}</h5></div><div class=\"ibox-content\"><h3>{{ vm.estrutura.NomeAtracao }}</h3></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-6\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Faturado</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">R$ {{vm.estrutura.Faturado | number: 2}}</h1></div></div></div><div class=\"col-md-6 col-sm-6\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Ingressos vendidos</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{vm.estrutura.QuantidadeOcupado}}</h1><div class=\"stat-percent font-bold\" style=\"color: #1ab394\">{{ vm.estrutura.Preenchido | number : 2 }}%</div><div class=\"progress progress-mini\"><div style=\"width: {{ vm.estrutura.Preenchido | number : 0 }}%\" class=\"progress-bar\"></div></div><small>Lotação: {{vm.estrutura.QtdLugaresMaxima}} lugares</small></div></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Detalhamento das vendas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-4\"><table class=\"table margin bottom\"><thead><tr><th>Descrição</th><th>Tipo</th><th class=\"text-center\">Ingressos</th><th class=\"text-center\">Valor</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.estrutura.Grid.Vendidos.dados\"><th rowspan=\"{{vm.estrutura.Grid.Vendidos.dados.length+1}}\" style=\"vertical-align: middle;\" ng-if=\"$index == 0\">Vendas</th><td>{{itm.TipoFormaPagamento}}</td><td class=\"text-right\"><span class=\"text-primary\">{{itm.Quantidade}}</span></td><td class=\"text-right\"><span class=\"text-info\">R$ {{itm.Valor | number : 2}}</span></td></tr><tr><th>Total</th><th class=\"text-right\"><span class=\"text-primary\">{{vm.estrutura.Grid.Vendidos.Total.Quantidade}}</span></th><th class=\"text-right\"><span class=\"text-info\">R$ {{vm.estrutura.Grid.Vendidos.Total.Valor | number : 2}}</span></th></tr><tr ng-repeat=\"itm in vm.estrutura.Grid.Devolvidos.dados\"><th rowspan=\"{{vm.estrutura.Grid.Devolvidos.dados.length+1}}\" style=\"vertical-align: middle;\" ng-if=\"$index == 0\">Devoluções</th><td>{{itm.TipoFormaPagamento}}</td><td class=\"text-right\"><span class=\"text-primary\">{{itm.Quantidade}}</span></td><td class=\"text-right\"><span class=\"text-danger\">R$ {{itm.Valor | number : 2}}</span></td></tr><tr><th>Total</th><th class=\"text-right\"><span class=\"text-primary\">{{vm.estrutura.Grid.Devolvidos.Total.Quantidade}}</span></th><th class=\"text-right\"><span class=\"text-danger\">R$ {{vm.estrutura.Grid.Devolvidos.Total.Valor | number : 2}}</span></th></tr><tr><th colspan=\"2\">Saldo</th><th class=\"text-right\"><span class=\"text-primary\">{{vm.estrutura.QuantidadeOcupado}}</span></th><th class=\"text-right\"><span class=\"text-success\">R$ {{vm.estrutura.Faturado | number: 2}}</span></th></tr></tbody></table></div><div class=\"col-lg-4\"><canvas class=\"chart-bar\" chart-data=\"vm.estrutura.Chart.valor.data\" chart-labels=\"vm.estrutura.Chart.labels\" chart-series=\"vm.estrutura.Chart.series\" chart-colors=\"vm.estrutura.Chart.colors\" chart-options=\"vm.estrutura.Chart.valor.options\" chart-click=\"onClick\"></canvas></div><div class=\"col-lg-4\"><canvas class=\"chart-bar\" chart-data=\"vm.estrutura.Chart.quantidade.data\" chart-labels=\"vm.estrutura.Chart.labels\" chart-series=\"vm.estrutura.Chart.series\" chart-colors=\"vm.estrutura.Chart.colors\" chart-options=\"vm.estrutura.Chart.quantidade.options\" chart-click=\"onClick\"></canvas></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 m-b-md\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.back();\">VOLTAR</button></div></div></div>");
$templateCache.put("view/site/home/index.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div ng-hide=\"true\" id=\"SEARCH\" ng-click=\"vm.search()\"></div><div ng-show=\"vm.empty\" class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\"><strong>Nenhuma venda encontrada</strong></div><div class=\"row\" ng-repeat=\"(key, value) in vm.items | orderBy: \'-DataHoraInicio\' | groupBy: \'Atracao\'\" infinite-scroll=\"vm.search(true)\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\"><div class=\"col-lg-12\"><div class=\"ibox-content\"><h4>{{value[0].Atracao}}</h4><hr><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr role=\"row\"><th th=\"\" style=\"width: 20px;\"></th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 710px;\">Sessão</th><th class=\"sorting center\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\">Total(%)</th><th style=\"width: 20px;\"></th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in value | orderBy: \'DataHoraInicio\'\"><td ng-click=\"vm.click(item)\"><span class=\"bar\" style=\"display: none;\">5,3,9,6,5,9,7,3,5,2</span><svg class=\"peity\" height=\"16\" width=\"32\"><rect fill=\"#1ab394\" x=\"0\" y=\"7.111111111111111\" width=\"2.3\" height=\"8.88888888888889\"></rect><rect fill=\"#d7d7d7\" x=\"3.3\" y=\"10.666666666666668\" width=\"2.3\" height=\"5.333333333333333\"></rect><rect fill=\"#1ab394\" x=\"6.6\" y=\"0\" width=\"2.3\" height=\"16\"></rect><rect fill=\"#d7d7d7\" x=\"9.899999999999999\" y=\"5.333333333333334\" width=\"2.3\" height=\"10.666666666666666\"></rect><rect fill=\"#1ab394\" x=\"13.2\" y=\"7.111111111111111\" width=\"2.3\" height=\"8.88888888888889\"></rect><rect fill=\"#d7d7d7\" x=\"16.5\" y=\"0\" width=\"2.3\" height=\"16\"></rect><rect fill=\"#1ab394\" x=\"19.799999999999997\" y=\"3.555555555555557\" width=\"2.3\" height=\"12.444444444444443\"></rect><rect fill=\"#d7d7d7\" x=\"23.099999999999998\" y=\"10.666666666666668\" width=\"2.3\" height=\"5.333333333333333\"></rect><rect fill=\"#1ab394\" x=\"26.4\" y=\"7.111111111111111\" width=\"2.3\" height=\"8.88888888888889\"></rect><rect fill=\"#d7d7d7\" x=\"29.7\" y=\"12.444444444444445\" width=\"2.3\" height=\"3.5555555555555554\"></rect></svg></td><td class=\"sorting_1\" ng-click=\"vm.click(item)\"><i class=\"fa fa-clock-o\"></i> {{item.DataHoraInicio | date : \'dd/MM\'}} as {{item.DataHoraInicio | date : \'HH:mm\'}}</td><td class=\"center text-navy\">{{item.QuantidadeVendida}} ({{item.PercentualVendido | number:2}}%)</td><td ng-click=\"vm.click(item)\"><i class=\"fa fa-chevron-right fa-1x\"></i></td></tr></tbody></table></div></div><br><br></div></div><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div><br></div>");
$templateCache.put("view/operacao/venda/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" ng-switch=\"vm.item.IdTipoStatusPagamento\"><h4 style=\"font-weight: 600\" ng-switch-when=\"1\">Detalhes da Venda (<label style=\"color: green;\" for=\"\">APROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"2\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">CANCELADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"3\">Detalhes da Venda (<label style=\"color: red;\" for=\"\">REPROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"4\">Detalhes da Venda (<label style=\"color: darkgrey;\" for=\"\">EM ANÁLISE</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"5\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">DEVOLVIDO</label>)</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table borderless table-condensed\"><tr><td><label>Estabelecimento:</label></td><td>{{vm.item.NomeEstabelecimento}}</td><td><label>Atração:</label></td><td>{{vm.item.NomeAtracao}}</td><td><label>Quantidade de Ingresso(s):</label></td><td>{{vm.item.QtdItens}}</td></tr><tr><td><label>Data Venda:</label></td><td>{{vm.item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</td><td><label>Data Contábil:</label></td><td>{{vm.item.DataContabil | date: \'dd/MM/yyyy\'}}</td><td><label>Data Sessão:</label></td><td>{{vm.item.DataHoraSessao | date: \'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Valor Bruto:</label></td><td>{{vm.item.ValorBruto | currency}}</td><td><label>Valor Liquido:</label></td><td>{{vm.item.ValorLiquido | currency}}</td><td><label>Valor Coveniência:</label></td><td>{{vm.item.ValorConveniencia | currency}}</td></tr><tr><td><label>Tipo Ingresso:</label></td><td>{{vm.QtdTipoIngresso}}</td><td><label>Assentos:</label></td><td>{{vm.item.Assentos}}</td><td><label>IdVenda</label></td><td>{{vm.item.IdVenda}}</td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Detalhes do Cliente</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table\"><tr><td><label>Cliente</label></td><td>{{vm.item.NomeCliente}}</td><td><label>Email</label></td><td>{{vm.item.Login}}</td><td><label for=\"\">Sexo</label></td><td>{{vm.item.Sexo}}</td><td><label for=\"\">CPF</label></td><td>{{vm.item.CPF}}</td></tr><tr><td><label for=\"\">Telefone</label></td><td>{{vm.item.Telefone}}</td><td><label for=\"\">Estado</label></td><td>{{vm.item.UF}}</td><td><label for=\"\">Cidade</label></td><td>{{vm.item.Cidade}}</td><td><label for=\"\">Bairro</label></td><td>{{vm.item.Bairro}}</td></tr><tr><td><label for=\"\">Provedor</label></td><td>{{vm.item.Provedor}}</td></tr></table></div></div></div><button class=\"btn btn-w-m btn-success pull-right col-offset-m1\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button></div></div></div>");
$templateCache.put("view/operacao/venda/grid.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.estabelecimentoList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" ng-disabled=\"!vm.atracaoList\" label=\"Atracao\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.atracaoList\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-12\"><h4>Período Data Venda</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataVendaInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataVendaFim\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 m-t-n-md\"><button ng-disabled=\"frm.$invalid || vm.searching\" style=\"margin-top: 26px\" type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div></form></div><br><div class=\"ibox-content\"><div class=\"table-responsive\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar as vendas\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Estabelecimento\">Estabelecimento</th><th ts-criteria=\"IdTipoStatusPagamento\">Status</th><th ts-criteria=\"Atracao\">Atração</th><th>Assentos</th><th>Quantidade</th><th ts-criteria=\"DataHoraInicio\">Data Sessão</th><th ts-criteria=\"DataVenda\" ts-default=\"descending\">Data Venda</th><th ts-criteria=\"DataContabil\">Data Contábil</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" role=\"row\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.NomeEstabelecimento}}</span></td><td ng-if=\"!item.FilaFraude\" ng-switch=\"item.IdTipoStatusPagamento\"><text style=\"color: green; font-weight: 600\" ng-switch-when=\"1\">Aprovada</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"2\">Cancelada</text><text style=\"color: red; font-weight: 600\" ng-switch-when=\"3\">Reprovada</text><text style=\"color: darkgrey; font-weight: 600\" ng-switch-when=\"4\">Em análise</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"5\">Devolvido</text></td><td ng-if=\"item.FilaFraude\"><text style=\"color: orangered; font-weight: 600\">Em análise</text></td><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.Assentos}}</span></td><td class=\"project-title\"><span>{{item.Qtd}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataContabil | date: \'dd/MM/yyyy\'}}</span></td><td class=\"center\" width=\"30\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.detalhe(item);\"><i class=\"fa fa-edit\"></i> Detalhe</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/operacao/venda/index.html","<div ui-view=\"\"></div>");}]);